/*!
 * GSAP 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle, jack@greensock.com
 */

!(function (t, e) {
  'object' == typeof exports && 'undefined' != typeof module
    ? e(exports)
    : 'function' == typeof define && define.amd
      ? define(['exports'], e)
      : e(((t = t || self).window = t.window || {}));
})(this, function (e) {
  'use strict';
  function _inheritsLoose(t, e) {
    ((t.prototype = Object.create(e.prototype)),
      ((t.prototype.constructor = t).__proto__ = e));
  }
  function _assertThisInitialized(t) {
    if (void 0 === t)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return t;
  }
  function r(t) {
    return 'string' == typeof t;
  }
  function s(t) {
    return 'function' == typeof t;
  }
  function t(t) {
    return 'number' == typeof t;
  }
  function u(t) {
    return void 0 === t;
  }
  function v(t) {
    return 'object' == typeof t;
  }
  function w(t) {
    return !1 !== t;
  }
  function x() {
    return 'undefined' != typeof window;
  }
  function y(t) {
    return s(t) || r(t);
  }
  function R(t) {
    return (i = bt(t, ht)) && Fe;
  }
  function S(t, e) {
    return console.warn(
      'Invalid property',
      t,
      'set to',
      e,
      'Missing plugin? gsap.registerPlugin()'
    );
  }
  function T(t, e) {
    return !e && console.warn(t);
  }
  function U(t, e) {
    return (t && (ht[t] = e) && i && (i[t] = e)) || ht;
  }
  function V() {
    return 0;
  }
  function ga(t) {
    var e,
      r,
      i = t[0];
    if ((v(i) || s(i) || (t = [t]), !(e = (i._gsap || {}).harness))) {
      for (r = yt.length; r-- && !yt[r].targetTest(i); );
      e = yt[r];
    }
    for (r = t.length; r--; )
      (t[r] && (t[r]._gsap || (t[r]._gsap = new Xt(t[r], e)))) ||
        t.splice(r, 1);
    return t;
  }
  function ha(t) {
    return t._gsap || ga(Pt(t))[0]._gsap;
  }
  function ia(t, e, r) {
    return (r = t[e]) && s(r)
      ? t[e]()
      : (u(r) && t.getAttribute && t.getAttribute(e)) || r;
  }
  function ja(t, e) {
    return (t = t.split(',')).forEach(e) || t;
  }
  function ka(t) {
    return Math.round(1e5 * t) / 1e5 || 0;
  }
  function la(t) {
    return Math.round(1e7 * t) / 1e7 || 0;
  }
  function ma(t, e) {
    var r = e.charAt(0),
      i = parseFloat(e.substr(2));
    return (
      (t = parseFloat(t)),
      '+' === r ? t + i : '-' === r ? t - i : '*' === r ? t * i : t / i
    );
  }
  function na(t, e) {
    for (var r = e.length, i = 0; t.indexOf(e[i]) < 0 && ++i < r; );
    return i < r;
  }
  function oa() {
    var t,
      e,
      r = pt.length,
      i = pt.slice(0);
    for (_t = {}, t = pt.length = 0; t < r; t++)
      (e = i[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
  }
  function pa(t) {
    return !!(t._initted || t._startAt || t.add);
  }
  function qa(t, e, r, i) {
    (pt.length && !I && oa(),
      t.render(e, r, i || !!(I && e < 0 && pa(t))),
      pt.length && !I && oa());
  }
  function ra(t) {
    var e = parseFloat(t);
    return (e || 0 === e) && (t + '').match(ot).length < 2
      ? e
      : r(t)
        ? t.trim()
        : t;
  }
  function sa(t) {
    return t;
  }
  function ta(t, e) {
    for (var r in e) r in t || (t[r] = e[r]);
    return t;
  }
  function wa(t, e) {
    for (var r in e)
      '__proto__' !== r &&
        'constructor' !== r &&
        'prototype' !== r &&
        (t[r] = v(e[r]) ? wa(t[r] || (t[r] = {}), e[r]) : e[r]);
    return t;
  }
  function xa(t, e) {
    var r,
      i = {};
    for (r in t) r in e || (i[r] = t[r]);
    return i;
  }
  function ya(t) {
    var e = t.parent || L,
      r = t.keyframes
        ? (function _setKeyframeDefaults(i) {
            return function (t, e) {
              for (var r in e)
                r in t ||
                  ('duration' === r && i) ||
                  'ease' === r ||
                  (t[r] = e[r]);
            };
          })(K(t.keyframes))
        : ta;
    if (w(t.inherit))
      for (; e; ) (r(t, e.vars.defaults), (e = e.parent || e._dp));
    return t;
  }
  function Aa(t, e, r, i, n) {
    (void 0 === r && (r = '_first'), void 0 === i && (i = '_last'));
    var a,
      s = t[i];
    if (n) for (a = e[n]; s && s[n] > a; ) s = s._prev;
    return (
      s ? ((e._next = s._next), (s._next = e)) : ((e._next = t[r]), (t[r] = e)),
      e._next ? (e._next._prev = e) : (t[i] = e),
      (e._prev = s),
      (e.parent = e._dp = t),
      e
    );
  }
  function Ba(t, e, r, i) {
    (void 0 === r && (r = '_first'), void 0 === i && (i = '_last'));
    var n = e._prev,
      a = e._next;
    (n ? (n._next = a) : t[r] === e && (t[r] = a),
      a ? (a._prev = n) : t[i] === e && (t[i] = n),
      (e._next = e._prev = e.parent = null));
  }
  function Ca(t, e) {
    (t.parent &&
      (!e || t.parent.autoRemoveChildren) &&
      t.parent.remove &&
      t.parent.remove(t),
      (t._act = 0));
  }
  function Da(t, e) {
    if (t && (!e || e._end > t._dur || e._start < 0))
      for (var r = t; r; ) ((r._dirty = 1), (r = r.parent));
    return t;
  }
  function Fa(t, e, r, i) {
    return (
      t._startAt &&
      (I
        ? t._startAt.revert(ft)
        : (t.vars.immediateRender && !t.vars.autoRevert) ||
          t._startAt.render(e, !0, i))
    );
  }
  function Ha(t) {
    return t._repeat ? wt(t._tTime, (t = t.duration() + t._rDelay)) * t : 0;
  }
  function Ja(t, e) {
    return (
      (t - e._start) * e._ts +
      (0 <= e._ts ? 0 : e._dirty ? e.totalDuration() : e._tDur)
    );
  }
  function Ka(t) {
    return (t._end = la(
      t._start + (t._tDur / Math.abs(t._ts || t._rts || q) || 0)
    ));
  }
  function La(t, e) {
    var r = t._dp;
    return (
      r &&
        r.smoothChildTiming &&
        t._ts &&
        ((t._start = la(
          r._time -
            (0 < t._ts
              ? e / t._ts
              : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)
        )),
        Ka(t),
        r._dirty || Da(r, t)),
      t
    );
  }
  function Ma(t, e) {
    var r;
    if (
      ((e._time ||
        (!e._dur && e._initted) ||
        (e._start < t._time && (e._dur || !e.add))) &&
        ((r = Ja(t.rawTime(), e)),
        (!e._dur || Mt(0, e.totalDuration(), r) - e._tTime > q) &&
          e.render(r, !0)),
      Da(t, e)._dp && t._initted && t._time >= t._dur && t._ts)
    ) {
      if (t._dur < t.duration())
        for (r = t; r._dp; )
          (0 <= r.rawTime() && r.totalTime(r._tTime), (r = r._dp));
      t._zTime = -q;
    }
  }
  function Na(e, r, i, n) {
    return (
      r.parent && Ca(r),
      (r._start = la(
        (t(i) ? i : i || e !== L ? Ot(e, i, r) : e._time) + r._delay
      )),
      (r._end = la(
        r._start + (r.totalDuration() / Math.abs(r.timeScale()) || 0)
      )),
      Aa(e, r, '_first', '_last', e._sort ? '_start' : 0),
      xt(r) || (e._recent = r),
      n || Ma(e, r),
      e._ts < 0 && La(e, e._tTime),
      e
    );
  }
  function Oa(t, e) {
    return (
      (ht.ScrollTrigger || S('scrollTrigger', e)) &&
      ht.ScrollTrigger.create(e, t)
    );
  }
  function Pa(t, e, r, i, n) {
    return (
      Ht(t, e, n),
      t._initted
        ? !r &&
          t._pt &&
          !I &&
          ((t._dur && !1 !== t.vars.lazy) || (!t._dur && t.vars.lazy)) &&
          f !== It.frame
          ? (pt.push(t), (t._lazy = [n, i]), 1)
          : void 0
        : 1
    );
  }
  function Ua(t, e, r, i) {
    var n = t._repeat,
      a = la(e) || 0,
      s = t._tTime / t._tDur;
    return (
      s && !i && (t._time *= a / t._dur),
      (t._dur = a),
      (t._tDur = n ? (n < 0 ? 1e10 : la(a * (n + 1) + t._rDelay * n)) : a),
      0 < s && !i && La(t, (t._tTime = t._tDur * s)),
      t.parent && Ka(t),
      r || Da(t.parent, t),
      t
    );
  }
  function Va(t) {
    return t instanceof Gt ? Da(t) : Ua(t, t._dur);
  }
  function Ya(e, r, i) {
    var n,
      a,
      s = t(r[1]),
      o = (s ? 2 : 1) + (e < 2 ? 0 : 1),
      u = r[o];
    if ((s && (u.duration = r[1]), (u.parent = i), e)) {
      for (n = u, a = i; a && !('immediateRender' in n); )
        ((n = a.vars.defaults || {}), (a = w(a.vars.inherit) && a.parent));
      ((u.immediateRender = w(n.immediateRender)),
        e < 2 ? (u.runBackwards = 1) : (u.startAt = r[o - 1]));
    }
    return new te(r[0], u, r[1 + o]);
  }
  function Za(t, e) {
    return t || 0 === t ? e(t) : e;
  }
  function _a(t, e) {
    return r(t) && (e = ut.exec(t)) ? e[1] : '';
  }
  function cb(t, e) {
    return (
      t &&
      v(t) &&
      'length' in t &&
      ((!e && !t.length) || (t.length - 1 in t && v(t[0]))) &&
      !t.nodeType &&
      t !== h
    );
  }
  function fb(r) {
    return (
      (r = Pt(r)[0] || T('Invalid scope') || {}),
      function (t) {
        var e = r.current || r.nativeElement || r;
        return Pt(
          t,
          e.querySelectorAll
            ? e
            : e === r
              ? T('Invalid scope') || a.createElement('div')
              : r
        );
      }
    );
  }
  function gb(t) {
    return t.sort(function () {
      return 0.5 - Math.random();
    });
  }
  function hb(t) {
    if (s(t)) return t;
    var p = v(t) ? t : { each: t },
      _ = jt(p.ease),
      m = p.from || 0,
      g = parseFloat(p.base) || 0,
      y = {},
      e = 0 < m && m < 1,
      T = isNaN(m) || e,
      b = p.axis,
      w = m,
      x = m;
    return (
      r(m)
        ? (w = x = { center: 0.5, edges: 0.5, end: 1 }[m] || 0)
        : !e && T && ((w = m[0]), (x = m[1])),
      function (t, e, r) {
        var i,
          n,
          a,
          s,
          o,
          u,
          h,
          l,
          f,
          c = (r || p).length,
          d = y[c];
        if (!d) {
          if (!(f = 'auto' === p.grid ? 0 : (p.grid || [1, X])[1])) {
            for (
              h = -X;
              h < (h = r[f++].getBoundingClientRect().left) && f < c;
            );
            f < c && f--;
          }
          for (
            d = y[c] = [],
              i = T ? Math.min(f, c) * w - 0.5 : m % f,
              n = f === X ? 0 : T ? (c * x) / f - 0.5 : (m / f) | 0,
              l = X,
              u = h = 0;
            u < c;
            u++
          )
            ((a = (u % f) - i),
              (s = n - ((u / f) | 0)),
              (d[u] = o = b ? Math.abs('y' === b ? s : a) : $(a * a + s * s)),
              h < o && (h = o),
              o < l && (l = o));
          ('random' === m && gb(d),
            (d.max = h - l),
            (d.min = l),
            (d.v = c =
              (parseFloat(p.amount) ||
                parseFloat(p.each) *
                  (c < f
                    ? c - 1
                    : b
                      ? 'y' === b
                        ? c / f
                        : f
                      : Math.max(f, c / f)) ||
                0) * ('edges' === m ? -1 : 1)),
            (d.b = c < 0 ? g - c : g),
            (d.u = _a(p.amount || p.each) || 0),
            (_ = _ && c < 0 ? Yt(_) : _));
        }
        return (
          (c = (d[t] - d.min) / d.max || 0),
          la(d.b + (_ ? _(c) : c) * d.v) + d.u
        );
      }
    );
  }
  function ib(i) {
    var n = Math.pow(10, ((i + '').split('.')[1] || '').length);
    return function (e) {
      var r = la(Math.round(parseFloat(e) / i) * i * n);
      return (r - (r % 1)) / n + (t(e) ? 0 : _a(e));
    };
  }
  function jb(h, e) {
    var l,
      f,
      r = K(h);
    return (
      !r &&
        v(h) &&
        ((l = r = h.radius || X),
        h.values
          ? ((h = Pt(h.values)), (f = !t(h[0])) && (l *= l))
          : (h = ib(h.increment))),
      Za(
        e,
        r
          ? s(h)
            ? function (t) {
                return ((f = h(t)), Math.abs(f - t) <= l ? f : t);
              }
            : function (e) {
                for (
                  var r,
                    i,
                    n = parseFloat(f ? e.x : e),
                    a = parseFloat(f ? e.y : 0),
                    s = X,
                    o = 0,
                    u = h.length;
                  u--;
                )
                  (r = f
                    ? (r = h[u].x - n) * r + (i = h[u].y - a) * i
                    : Math.abs(h[u] - n)) < s && ((s = r), (o = u));
                return (
                  (o = !l || s <= l ? h[o] : e),
                  f || o === e || t(e) ? o : o + _a(e)
                );
              }
          : ib(h)
      )
    );
  }
  function kb(t, e, r, i) {
    return Za(K(t) ? !e : !0 === r ? !!(r = 0) : !i, function () {
      return K(t)
        ? t[~~(Math.random() * t.length)]
        : (r = r || 1e-5) &&
            (i = r < 1 ? Math.pow(10, (r + '').length - 2) : 1) &&
            Math.floor(
              Math.round((t - r / 2 + Math.random() * (e - t + 0.99 * r)) / r) *
                r *
                i
            ) / i;
    });
  }
  function ob(e, r, t) {
    return Za(t, function (t) {
      return e[~~r(t)];
    });
  }
  function rb(t) {
    return t.replace(tt, function (t) {
      var e = t.indexOf('[') + 1,
        r = t.substring(e || 7, e ? t.indexOf(']') : t.length - 1).split(et);
      return kb(e ? r : +r[0], e ? 0 : +r[1], +r[2] || 1e-5);
    });
  }
  function ub(t, e, r) {
    var i,
      n,
      a,
      s = t.labels,
      o = X;
    for (i in s)
      (n = s[i] - e) < 0 == !!r &&
        n &&
        o > (n = Math.abs(n)) &&
        ((a = i), (o = n));
    return a;
  }
  function wb(t) {
    return (
      Ca(t),
      t.scrollTrigger && t.scrollTrigger.kill(!!I),
      t.progress() < 1 && At(t, 'onInterrupt'),
      t
    );
  }
  function zb(t) {
    if (t)
      if (((t = (!t.name && t.default) || t), x() || t.headless)) {
        var e = t.name,
          r = s(t),
          i =
            e && !r && t.init
              ? function () {
                  this._props = [];
                }
              : t,
          n = {
            init: V,
            render: _e,
            add: $t,
            kill: Te,
            modifier: ve,
            rawVars: 0,
          },
          a = {
            targetTest: 0,
            get: 0,
            getSetter: ue,
            aliases: {},
            register: 0,
          };
        if ((Lt(), t !== i)) {
          if (mt[e]) return;
          (ta(i, ta(xa(t, n), a)),
            bt(i.prototype, bt(n, xa(t, a))),
            (mt[(i.prop = e)] = i),
            t.targetTest && (yt.push(i), (dt[e] = 1)),
            (e =
              ('css' === e ? 'CSS' : e.charAt(0).toUpperCase() + e.substr(1)) +
              'Plugin'));
        }
        (U(e, i), t.register && t.register(Fe, i, we));
      } else Dt.push(t);
  }
  function Cb(t, e, r) {
    return (
      ((6 * (t += t < 0 ? 1 : 1 < t ? -1 : 0) < 1
        ? e + (r - e) * t * 6
        : t < 0.5
          ? r
          : 3 * t < 2
            ? e + (r - e) * (2 / 3 - t) * 6
            : e) *
        zt +
        0.5) |
      0
    );
  }
  function Db(e, r, i) {
    var n,
      a,
      s,
      o,
      u,
      h,
      l,
      f,
      c,
      d,
      p = e ? (t(e) ? [e >> 16, (e >> 8) & zt, e & zt] : 0) : Rt.black;
    if (!p) {
      if ((',' === e.substr(-1) && (e = e.substr(0, e.length - 1)), Rt[e]))
        p = Rt[e];
      else if ('#' === e.charAt(0)) {
        if (
          (e.length < 6 &&
            (e =
              '#' +
              (n = e.charAt(1)) +
              n +
              (a = e.charAt(2)) +
              a +
              (s = e.charAt(3)) +
              s +
              (5 === e.length ? e.charAt(4) + e.charAt(4) : '')),
          9 === e.length)
        )
          return [
            (p = parseInt(e.substr(1, 6), 16)) >> 16,
            (p >> 8) & zt,
            p & zt,
            parseInt(e.substr(7), 16) / 255,
          ];
        p = [(e = parseInt(e.substr(1), 16)) >> 16, (e >> 8) & zt, e & zt];
      } else if ('hsl' === e.substr(0, 3))
        if (((p = d = e.match(rt)), r)) {
          if (~e.indexOf('='))
            return ((p = e.match(it)), i && p.length < 4 && (p[3] = 1), p);
        } else
          ((o = (+p[0] % 360) / 360),
            (u = p[1] / 100),
            (n =
              2 * (h = p[2] / 100) -
              (a = h <= 0.5 ? h * (u + 1) : h + u - h * u)),
            3 < p.length && (p[3] *= 1),
            (p[0] = Cb(o + 1 / 3, n, a)),
            (p[1] = Cb(o, n, a)),
            (p[2] = Cb(o - 1 / 3, n, a)));
      else p = e.match(rt) || Rt.transparent;
      p = p.map(Number);
    }
    return (
      r &&
        !d &&
        ((n = p[0] / zt),
        (a = p[1] / zt),
        (s = p[2] / zt),
        (h = ((l = Math.max(n, a, s)) + (f = Math.min(n, a, s))) / 2),
        l === f
          ? (o = u = 0)
          : ((c = l - f),
            (u = 0.5 < h ? c / (2 - l - f) : c / (l + f)),
            (o =
              l === n
                ? (a - s) / c + (a < s ? 6 : 0)
                : l === a
                  ? (s - n) / c + 2
                  : (n - a) / c + 4),
            (o *= 60)),
        (p[0] = ~~(o + 0.5)),
        (p[1] = ~~(100 * u + 0.5)),
        (p[2] = ~~(100 * h + 0.5))),
      i && p.length < 4 && (p[3] = 1),
      p
    );
  }
  function Eb(t) {
    var r = [],
      i = [],
      n = -1;
    return (
      t.split(Et).forEach(function (t) {
        var e = t.match(nt) || [];
        (r.push.apply(r, e), i.push((n += e.length + 1)));
      }),
      (r.c = i),
      r
    );
  }
  function Fb(t, e, r) {
    var i,
      n,
      a,
      s,
      o = '',
      u = (t + o).match(Et),
      h = e ? 'hsla(' : 'rgba(',
      l = 0;
    if (!u) return t;
    if (
      ((u = u.map(function (t) {
        return (
          (t = Db(t, e, 1)) &&
          h +
            (e ? t[0] + ',' + t[1] + '%,' + t[2] + '%,' + t[3] : t.join(',')) +
            ')'
        );
      })),
      r && ((a = Eb(t)), (i = r.c).join(o) !== a.c.join(o)))
    )
      for (s = (n = t.replace(Et, '1').split(nt)).length - 1; l < s; l++)
        o +=
          n[l] +
          (~i.indexOf(l)
            ? u.shift() || h + '0,0,0,0)'
            : (a.length ? a : u.length ? u : r).shift());
    if (!n) for (s = (n = t.split(Et)).length - 1; l < s; l++) o += n[l] + u[l];
    return o + n[s];
  }
  function Ib(t) {
    var e,
      r = t.join(' ');
    if (((Et.lastIndex = 0), Et.test(r)))
      return (
        (e = Ft.test(r)),
        (t[1] = Fb(t[1], e)),
        (t[0] = Fb(t[0], e, Eb(t[1]))),
        !0
      );
  }
  function Rb(t) {
    var e = (t + '').split('('),
      r = Bt[e[0]];
    return r && 1 < e.length && r.config
      ? r.config.apply(
          null,
          ~t.indexOf('{')
            ? [
                (function _parseObjectInString(t) {
                  for (
                    var e,
                      r,
                      i,
                      n = {},
                      a = t.substr(1, t.length - 3).split(':'),
                      s = a[0],
                      o = 1,
                      u = a.length;
                    o < u;
                    o++
                  )
                    ((r = a[o]),
                      (e = o !== u - 1 ? r.lastIndexOf(',') : r.length),
                      (i = r.substr(0, e)),
                      (n[s] = isNaN(i) ? i.replace(Ut, '').trim() : +i),
                      (s = r.substr(e + 1).trim()));
                  return n;
                })(e[1]),
              ]
            : (function _valueInParentheses(t) {
                var e = t.indexOf('(') + 1,
                  r = t.indexOf(')'),
                  i = t.indexOf('(', e);
                return t.substring(e, ~i && i < r ? t.indexOf(')', r + 1) : r);
              })(t)
                .split(',')
                .map(ra)
        )
      : Bt._CE && Nt.test(t)
        ? Bt._CE('', t)
        : r;
  }
  function Ub(t, e, r, i) {
    (void 0 === r &&
      (r = function easeOut(t) {
        return 1 - e(1 - t);
      }),
      void 0 === i &&
        (i = function easeInOut(t) {
          return t < 0.5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2;
        }));
    var n,
      a = { easeIn: e, easeOut: r, easeInOut: i };
    return (
      ja(t, function (t) {
        for (var e in ((Bt[t] = ht[t] = a), (Bt[(n = t.toLowerCase())] = r), a))
          Bt[
            n + ('easeIn' === e ? '.in' : 'easeOut' === e ? '.out' : '.inOut')
          ] = Bt[t + '.' + e] = a[e];
      }),
      a
    );
  }
  function Vb(e) {
    return function (t) {
      return t < 0.5 ? (1 - e(1 - 2 * t)) / 2 : 0.5 + e(2 * (t - 0.5)) / 2;
    };
  }
  function Wb(r, t, e) {
    function Gm(t) {
      return 1 === t ? 1 : i * Math.pow(2, -10 * t) * Q((t - a) * n) + 1;
    }
    var i = 1 <= t ? t : 1,
      n = (e || (r ? 0.3 : 0.45)) / (t < 1 ? t : 1),
      a = (n / G) * (Math.asin(1 / i) || 0),
      s =
        'out' === r
          ? Gm
          : 'in' === r
            ? function (t) {
                return 1 - Gm(1 - t);
              }
            : Vb(Gm);
    return (
      (n = G / n),
      (s.config = function (t, e) {
        return Wb(r, t, e);
      }),
      s
    );
  }
  function Xb(e, r) {
    function Om(t) {
      return t ? --t * t * ((r + 1) * t + r) + 1 : 0;
    }
    void 0 === r && (r = 1.70158);
    var t =
      'out' === e
        ? Om
        : 'in' === e
          ? function (t) {
              return 1 - Om(1 - t);
            }
          : Vb(Om);
    return (
      (t.config = function (t) {
        return Xb(e, t);
      }),
      t
    );
  }
  var F,
    I,
    l,
    L,
    h,
    n,
    a,
    i,
    o,
    f,
    c,
    d,
    p,
    _,
    m,
    g,
    b,
    k,
    O,
    M,
    C,
    P,
    A,
    D,
    z,
    E,
    B,
    N,
    Y = {
      autoSleep: 120,
      force3D: 'auto',
      nullTargetWarn: 1,
      units: { lineHeight: '' },
    },
    j = { duration: 0.5, overwrite: !1, delay: 0 },
    X = 1e8,
    q = 1 / X,
    G = 2 * Math.PI,
    Z = G / 4,
    W = 0,
    $ = Math.sqrt,
    H = Math.cos,
    Q = Math.sin,
    J =
      ('function' == typeof ArrayBuffer && ArrayBuffer.isView) ||
      function () {},
    K = Array.isArray,
    tt = /random\([^)]+\)/g,
    et = /,\s*/g,
    rt = /(?:-?\.?\d|\.)+/gi,
    it = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
    nt = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
    at = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
    st = /[+-]=-?[.\d]+/,
    ot = /[^,'"\[\]\s]+/gi,
    ut = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
    ht = {},
    lt = { suppressEvents: !0, isStart: !0, kill: !1 },
    ft = { suppressEvents: !0, kill: !1 },
    ct = { suppressEvents: !0 },
    dt = {},
    pt = [],
    _t = {},
    mt = {},
    gt = {},
    vt = 30,
    yt = [],
    Tt = '',
    bt = function _merge(t, e) {
      for (var r in e) t[r] = e[r];
      return t;
    },
    wt = function _animationCycle(t, e) {
      var r = Math.floor((t = la(t / e)));
      return t && r === t ? r - 1 : r;
    },
    xt = function _isFromOrFromStart(t) {
      var e = t.data;
      return 'isFromStart' === e || 'isStart' === e;
    },
    kt = { _start: 0, endTime: V, totalDuration: V },
    Ot = function _parsePosition(t, e, i) {
      var n,
        a,
        s,
        o = t.labels,
        u = t._recent || kt,
        h = t.duration() >= X ? u.endTime(!1) : t._dur;
      return r(e) && (isNaN(e) || e in o)
        ? ((a = e.charAt(0)),
          (s = '%' === e.substr(-1)),
          (n = e.indexOf('=')),
          '<' === a || '>' === a
            ? (0 <= n && (e = e.replace(/=/, '')),
              ('<' === a ? u._start : u.endTime(0 <= u._repeat)) +
                (parseFloat(e.substr(1)) || 0) *
                  (s ? (n < 0 ? u : i).totalDuration() / 100 : 1))
            : n < 0
              ? (e in o || (o[e] = h), o[e])
              : ((a = parseFloat(e.charAt(n - 1) + e.substr(n + 1))),
                s && i && (a = (a / 100) * (K(i) ? i[0] : i).totalDuration()),
                1 < n ? _parsePosition(t, e.substr(0, n - 1), i) + a : h + a))
        : null == e
          ? h
          : +e;
    },
    Mt = function _clamp(t, e, r) {
      return r < t ? t : e < r ? e : r;
    },
    Ct = [].slice,
    Pt = function toArray(t, e, i) {
      return l && !e && l.selector
        ? l.selector(t)
        : !r(t) || i || (!n && Lt())
          ? K(t)
            ? (function _flatten(t, e, i) {
                return (
                  void 0 === i && (i = []),
                  t.forEach(function (t) {
                    return (r(t) && !e) || cb(t, 1)
                      ? i.push.apply(i, Pt(t))
                      : i.push(t);
                  }) || i
                );
              })(t, i)
            : cb(t)
              ? Ct.call(t, 0)
              : t
                ? [t]
                : []
          : Ct.call((e || a).querySelectorAll(t), 0);
    },
    St = function mapRange(e, t, r, i, n) {
      var a = t - e,
        s = i - r;
      return Za(n, function (t) {
        return r + (((t - e) / a) * s || 0);
      });
    },
    At = function _callback(t, e, r) {
      var i,
        n,
        a,
        s = t.vars,
        o = s[e],
        u = l,
        h = t._ctx;
      if (o)
        return (
          (i = s[e + 'Params']),
          (n = s.callbackScope || t),
          r && pt.length && oa(),
          h && (l = h),
          (a = i ? o.apply(n, i) : o.call(n)),
          (l = u),
          a
        );
    },
    Dt = [],
    zt = 255,
    Rt = {
      aqua: [0, zt, zt],
      lime: [0, zt, 0],
      silver: [192, 192, 192],
      black: [0, 0, 0],
      maroon: [128, 0, 0],
      teal: [0, 128, 128],
      blue: [0, 0, zt],
      navy: [0, 0, 128],
      white: [zt, zt, zt],
      olive: [128, 128, 0],
      yellow: [zt, zt, 0],
      orange: [zt, 165, 0],
      gray: [128, 128, 128],
      purple: [128, 0, 128],
      green: [0, 128, 0],
      red: [zt, 0, 0],
      pink: [zt, 192, 203],
      cyan: [0, zt, zt],
      transparent: [zt, zt, zt, 0],
    },
    Et = (function () {
      var t,
        e =
          '(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b';
      for (t in Rt) e += '|' + t + '\\b';
      return new RegExp(e + ')', 'gi');
    })(),
    Ft = /hsl[a]?\(/,
    It =
      ((O = Date.now),
      (M = 500),
      (C = 33),
      (P = O()),
      (A = P),
      (z = D = 1e3 / 240),
      (g = {
        time: 0,
        frame: 0,
        tick: function tick() {
          zl(!0);
        },
        deltaRatio: function deltaRatio(t) {
          return b / (1e3 / (t || 60));
        },
        wake: function wake() {
          o &&
            (!n &&
              x() &&
              ((h = n = window),
              (a = h.document || {}),
              (ht.gsap = Fe),
              (h.gsapVersions || (h.gsapVersions = [])).push(Fe.version),
              R(i || h.GreenSockGlobals || (!h.gsap && h) || {}),
              Dt.forEach(zb)),
            (m =
              'undefined' != typeof requestAnimationFrame &&
              requestAnimationFrame),
            p && g.sleep(),
            (_ =
              m ||
              function (t) {
                return setTimeout(t, (z - 1e3 * g.time + 1) | 0);
              }),
            (d = 1),
            zl(2));
        },
        sleep: function sleep() {
          ((m ? cancelAnimationFrame : clearTimeout)(p), (d = 0), (_ = V));
        },
        lagSmoothing: function lagSmoothing(t, e) {
          ((M = t || 1 / 0), (C = Math.min(e || 33, M)));
        },
        fps: function fps(t) {
          ((D = 1e3 / (t || 240)), (z = 1e3 * g.time + D));
        },
        add: function add(n, t, e) {
          var a = t
            ? function (t, e, r, i) {
                (n(t, e, r, i), g.remove(a));
              }
            : n;
          return (g.remove(n), E[e ? 'unshift' : 'push'](a), Lt(), a);
        },
        remove: function remove(t, e) {
          ~(e = E.indexOf(t)) && E.splice(e, 1) && e <= k && k--;
        },
        _listeners: (E = []),
      })),
    Lt = function _wake() {
      return !d && It.wake();
    },
    Bt = {},
    Nt = /^[\d.\-M][\d.\-,\s]/,
    Ut = /["']/g,
    Yt = function _invertEase(e) {
      return function (t) {
        return 1 - e(1 - t);
      };
    },
    jt = function _parseEase(t, e) {
      return (t && (s(t) ? t : Bt[t] || Rb(t))) || e;
    };
  function zl(t) {
    var e,
      r,
      i,
      n,
      a = O() - A,
      s = !0 === t;
    if (
      ((M < a || a < 0) && (P += a - C),
      (0 < (e = (i = (A += a) - P) - z) || s) &&
        ((n = ++g.frame),
        (b = i - 1e3 * g.time),
        (g.time = i /= 1e3),
        (z += e + (D <= e ? 4 : D - e)),
        (r = 1)),
      s || (p = _(zl)),
      r)
    )
      for (k = 0; k < E.length; k++) E[k](i, b, n, t);
  }
  function dn(t) {
    return t < N
      ? B * t * t
      : t < 0.7272727272727273
        ? B * Math.pow(t - 1.5 / 2.75, 2) + 0.75
        : t < 0.9090909090909092
          ? B * (t -= 2.25 / 2.75) * t + 0.9375
          : B * Math.pow(t - 2.625 / 2.75, 2) + 0.984375;
  }
  (ja('Linear,Quad,Cubic,Quart,Quint,Strong', function (t, e) {
    var r = e < 5 ? e + 1 : e;
    Ub(
      t + ',Power' + (r - 1),
      e
        ? function (t) {
            return Math.pow(t, r);
          }
        : function (t) {
            return t;
          },
      function (t) {
        return 1 - Math.pow(1 - t, r);
      },
      function (t) {
        return t < 0.5
          ? Math.pow(2 * t, r) / 2
          : 1 - Math.pow(2 * (1 - t), r) / 2;
      }
    );
  }),
    (Bt.Linear.easeNone = Bt.none = Bt.Linear.easeIn),
    Ub('Elastic', Wb('in'), Wb('out'), Wb()),
    (B = 7.5625),
    (N = 1 / 2.75),
    Ub(
      'Bounce',
      function (t) {
        return 1 - dn(1 - t);
      },
      dn
    ),
    Ub('Expo', function (t) {
      return Math.pow(2, 10 * (t - 1)) * t + t * t * t * t * t * t * (1 - t);
    }),
    Ub('Circ', function (t) {
      return -($(1 - t * t) - 1);
    }),
    Ub('Sine', function (t) {
      return 1 === t ? 1 : 1 - H(t * Z);
    }),
    Ub('Back', Xb('in'), Xb('out'), Xb()),
    (Bt.SteppedEase =
      Bt.steps =
      ht.SteppedEase =
        {
          config: function config(t, e) {
            void 0 === t && (t = 1);
            var r = 1 / t,
              i = t + (e ? 0 : 1),
              n = e ? 1 : 0;
            return function (t) {
              return (((i * Mt(0, 0.99999999, t)) | 0) + n) * r;
            };
          },
        }),
    (j.ease = Bt['quad.out']),
    ja(
      'onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt',
      function (t) {
        return (Tt += t + ',' + t + 'Params,');
      }
    ));
  var Vt,
    Xt = function GSCache(t, e) {
      ((this.id = W++),
        ((t._gsap = this).target = t),
        (this.harness = e),
        (this.get = e ? e.get : ia),
        (this.set = e ? e.getSetter : ue));
    },
    qt =
      (((Vt = Animation.prototype).delay = function delay(t) {
        return t || 0 === t
          ? (this.parent &&
              this.parent.smoothChildTiming &&
              this.startTime(this._start + t - this._delay),
            (this._delay = t),
            this)
          : this._delay;
      }),
      (Vt.duration = function duration(t) {
        return arguments.length
          ? this.totalDuration(
              0 < this._repeat ? t + (t + this._rDelay) * this._repeat : t
            )
          : this.totalDuration() && this._dur;
      }),
      (Vt.totalDuration = function totalDuration(t) {
        return arguments.length
          ? ((this._dirty = 0),
            Ua(
              this,
              this._repeat < 0
                ? t
                : (t - this._repeat * this._rDelay) / (this._repeat + 1)
            ))
          : this._tDur;
      }),
      (Vt.totalTime = function totalTime(t, e) {
        if ((Lt(), !arguments.length)) return this._tTime;
        var r = this._dp;
        if (r && r.smoothChildTiming && this._ts) {
          for (La(this, t), !r._dp || r.parent || Ma(r, this); r && r.parent; )
            (r.parent._time !==
              r._start +
                (0 <= r._ts
                  ? r._tTime / r._ts
                  : (r.totalDuration() - r._tTime) / -r._ts) &&
              r.totalTime(r._tTime, !0),
              (r = r.parent));
          !this.parent &&
            this._dp.autoRemoveChildren &&
            ((0 < this._ts && t < this._tDur) ||
              (this._ts < 0 && 0 < t) ||
              (!this._tDur && !t)) &&
            Na(this._dp, this, this._start - this._delay);
        }
        return (
          (this._tTime !== t ||
            (!this._dur && !e) ||
            (this._initted && Math.abs(this._zTime) === q) ||
            (!this._initted && this._dur && t) ||
            (!t && !this._initted && (this.add || this._ptLookup))) &&
            (this._ts || (this._pTime = t), qa(this, t, e)),
          this
        );
      }),
      (Vt.time = function time(t, e) {
        return arguments.length
          ? this.totalTime(
              Math.min(this.totalDuration(), t + Ha(this)) %
                (this._dur + this._rDelay) || (t ? this._dur : 0),
              e
            )
          : this._time;
      }),
      (Vt.totalProgress = function totalProgress(t, e) {
        return arguments.length
          ? this.totalTime(this.totalDuration() * t, e)
          : this.totalDuration()
            ? Math.min(1, this._tTime / this._tDur)
            : 0 <= this.rawTime() && this._initted
              ? 1
              : 0;
      }),
      (Vt.progress = function progress(t, e) {
        return arguments.length
          ? this.totalTime(
              this.duration() *
                (!this._yoyo || 1 & this.iteration() ? t : 1 - t) +
                Ha(this),
              e
            )
          : this.duration()
            ? Math.min(1, this._time / this._dur)
            : 0 < this.rawTime()
              ? 1
              : 0;
      }),
      (Vt.iteration = function iteration(t, e) {
        var r = this.duration() + this._rDelay;
        return arguments.length
          ? this.totalTime(this._time + (t - 1) * r, e)
          : this._repeat
            ? wt(this._tTime, r) + 1
            : 1;
      }),
      (Vt.timeScale = function timeScale(t, e) {
        if (!arguments.length) return this._rts === -q ? 0 : this._rts;
        if (this._rts === t) return this;
        var r =
          this.parent && this._ts ? Ja(this.parent._time, this) : this._tTime;
        return (
          (this._rts = +t || 0),
          (this._ts = this._ps || t === -q ? 0 : this._rts),
          this.totalTime(
            Mt(-Math.abs(this._delay), this.totalDuration(), r),
            !1 !== e
          ),
          Ka(this),
          (function _recacheAncestors(t) {
            for (var e = t.parent; e && e.parent; )
              ((e._dirty = 1), e.totalDuration(), (e = e.parent));
            return t;
          })(this)
        );
      }),
      (Vt.paused = function paused(t) {
        return arguments.length
          ? (this._ps !== t &&
              ((this._ps = t)
                ? ((this._pTime =
                    this._tTime || Math.max(-this._delay, this.rawTime())),
                  (this._ts = this._act = 0))
                : (Lt(),
                  (this._ts = this._rts),
                  this.totalTime(
                    this.parent && !this.parent.smoothChildTiming
                      ? this.rawTime()
                      : this._tTime || this._pTime,
                    1 === this.progress() &&
                      Math.abs(this._zTime) !== q &&
                      (this._tTime -= q)
                  ))),
            this)
          : this._ps;
      }),
      (Vt.startTime = function startTime(t) {
        if (arguments.length) {
          this._start = la(t);
          var e = this.parent || this._dp;
          return (
            !e ||
              (!e._sort && this.parent) ||
              Na(e, this, this._start - this._delay),
            this
          );
        }
        return this._start;
      }),
      (Vt.endTime = function endTime(t) {
        return (
          this._start +
          (w(t) ? this.totalDuration() : this.duration()) /
            Math.abs(this._ts || 1)
        );
      }),
      (Vt.rawTime = function rawTime(t) {
        var e = this.parent || this._dp;
        return e
          ? t &&
            (!this._ts ||
              (this._repeat && this._time && this.totalProgress() < 1))
            ? this._tTime % (this._dur + this._rDelay)
            : this._ts
              ? Ja(e.rawTime(t), this)
              : this._tTime
          : this._tTime;
      }),
      (Vt.revert = function revert(t) {
        void 0 === t && (t = ct);
        var e = I;
        return (
          (I = t),
          pa(this) &&
            (this.timeline && this.timeline.revert(t),
            this.totalTime(-0.01, t.suppressEvents)),
          'nested' !== this.data && !1 !== t.kill && this.kill(),
          (I = e),
          this
        );
      }),
      (Vt.globalTime = function globalTime(t) {
        for (var e = this, r = arguments.length ? t : e.rawTime(); e; )
          ((r = e._start + r / (Math.abs(e._ts) || 1)), (e = e._dp));
        return !this.parent && this._sat ? this._sat.globalTime(t) : r;
      }),
      (Vt.repeat = function repeat(t) {
        return arguments.length
          ? ((this._repeat = t === 1 / 0 ? -2 : t), Va(this))
          : -2 === this._repeat
            ? 1 / 0
            : this._repeat;
      }),
      (Vt.repeatDelay = function repeatDelay(t) {
        if (arguments.length) {
          var e = this._time;
          return ((this._rDelay = t), Va(this), e ? this.time(e) : this);
        }
        return this._rDelay;
      }),
      (Vt.yoyo = function yoyo(t) {
        return arguments.length ? ((this._yoyo = t), this) : this._yoyo;
      }),
      (Vt.seek = function seek(t, e) {
        return this.totalTime(Ot(this, t), w(e));
      }),
      (Vt.restart = function restart(t, e) {
        return (
          this.play().totalTime(t ? -this._delay : 0, w(e)),
          this._dur || (this._zTime = -q),
          this
        );
      }),
      (Vt.play = function play(t, e) {
        return (null != t && this.seek(t, e), this.reversed(!1).paused(!1));
      }),
      (Vt.reverse = function reverse(t, e) {
        return (
          null != t && this.seek(t || this.totalDuration(), e),
          this.reversed(!0).paused(!1)
        );
      }),
      (Vt.pause = function pause(t, e) {
        return (null != t && this.seek(t, e), this.paused(!0));
      }),
      (Vt.resume = function resume() {
        return this.paused(!1);
      }),
      (Vt.reversed = function reversed(t) {
        return arguments.length
          ? (!!t !== this.reversed() &&
              this.timeScale(-this._rts || (t ? -q : 0)),
            this)
          : this._rts < 0;
      }),
      (Vt.invalidate = function invalidate() {
        return ((this._initted = this._act = 0), (this._zTime = -q), this);
      }),
      (Vt.isActive = function isActive() {
        var t,
          e = this.parent || this._dp,
          r = this._start;
        return !(
          e &&
          !(
            this._ts &&
            this._initted &&
            e.isActive() &&
            (t = e.rawTime(!0)) >= r &&
            t < this.endTime(!0) - q
          )
        );
      }),
      (Vt.eventCallback = function eventCallback(t, e, r) {
        var i = this.vars;
        return 1 < arguments.length
          ? (e
              ? ((i[t] = e),
                r && (i[t + 'Params'] = r),
                'onUpdate' === t && (this._onUpdate = e))
              : delete i[t],
            this)
          : i[t];
      }),
      (Vt.then = function then(t) {
        var i = this,
          n = i._prom;
        return new Promise(function (e) {
          function Ao() {
            var t = i.then;
            ((i.then = null),
              n && n(),
              s(r) && (r = r(i)) && (r.then || r === i) && (i.then = t),
              e(r),
              (i.then = t));
          }
          var r = s(t) ? t : sa;
          (i._initted && 1 === i.totalProgress() && 0 <= i._ts) ||
          (!i._tTime && i._ts < 0)
            ? Ao()
            : (i._prom = Ao);
        });
      }),
      (Vt.kill = function kill() {
        wb(this);
      }),
      Animation);
  function Animation(t) {
    ((this.vars = t),
      (this._delay = +t.delay || 0),
      (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) &&
        ((this._rDelay = t.repeatDelay || 0),
        (this._yoyo = !!t.yoyo || !!t.yoyoEase)),
      (this._ts = 1),
      Ua(this, +t.duration, 1, 1),
      (this.data = t.data),
      l && (this._ctx = l).data.push(this),
      d || It.wake());
  }
  ta(qt.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: !1,
    parent: null,
    _initted: !1,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -q,
    _prom: 0,
    _ps: !1,
    _rts: 1,
  });
  var Gt = (function (i) {
    function Timeline(t, e) {
      var r;
      return (
        void 0 === t && (t = {}),
        ((r = i.call(this, t) || this).labels = {}),
        (r.smoothChildTiming = !!t.smoothChildTiming),
        (r.autoRemoveChildren = !!t.autoRemoveChildren),
        (r._sort = w(t.sortChildren)),
        L && Na(t.parent || L, _assertThisInitialized(r), e),
        t.reversed && r.reverse(),
        t.paused && r.paused(!0),
        t.scrollTrigger && Oa(_assertThisInitialized(r), t.scrollTrigger),
        r
      );
    }
    _inheritsLoose(Timeline, i);
    var e = Timeline.prototype;
    return (
      (e.to = function to(t, e, r) {
        return (Ya(0, arguments, this), this);
      }),
      (e.from = function from(t, e, r) {
        return (Ya(1, arguments, this), this);
      }),
      (e.fromTo = function fromTo(t, e, r, i) {
        return (Ya(2, arguments, this), this);
      }),
      (e.set = function set(t, e, r) {
        return (
          (e.duration = 0),
          (e.parent = this),
          ya(e).repeatDelay || (e.repeat = 0),
          (e.immediateRender = !!e.immediateRender),
          new te(t, e, Ot(this, r), 1),
          this
        );
      }),
      (e.call = function call(t, e, r) {
        return Na(this, te.delayedCall(0, t, e), r);
      }),
      (e.staggerTo = function staggerTo(t, e, r, i, n, a, s) {
        return (
          (r.duration = e),
          (r.stagger = r.stagger || i),
          (r.onComplete = a),
          (r.onCompleteParams = s),
          (r.parent = this),
          new te(t, r, Ot(this, n)),
          this
        );
      }),
      (e.staggerFrom = function staggerFrom(t, e, r, i, n, a, s) {
        return (
          (r.runBackwards = 1),
          (ya(r).immediateRender = w(r.immediateRender)),
          this.staggerTo(t, e, r, i, n, a, s)
        );
      }),
      (e.staggerFromTo = function staggerFromTo(t, e, r, i, n, a, s, o) {
        return (
          (i.startAt = r),
          (ya(i).immediateRender = w(i.immediateRender)),
          this.staggerTo(t, e, i, n, a, s, o)
        );
      }),
      (e.render = function render(t, e, r) {
        var i,
          n,
          a,
          s,
          o,
          u,
          h,
          l,
          f,
          c,
          d,
          p,
          _ = this._time,
          m = this._dirty ? this.totalDuration() : this._tDur,
          g = this._dur,
          v = t <= 0 ? 0 : la(t),
          y = this._zTime < 0 != t < 0 && (this._initted || !g);
        if (
          (this !== L && m < v && 0 <= t && (v = m),
          v !== this._tTime || r || y)
        ) {
          if (
            (_ !== this._time &&
              g &&
              ((v += this._time - _), (t += this._time - _)),
            (i = v),
            (f = this._start),
            (u = !(l = this._ts)),
            y && (g || (_ = this._zTime), (!t && e) || (this._zTime = t)),
            this._repeat)
          ) {
            if (
              ((d = this._yoyo),
              (o = g + this._rDelay),
              this._repeat < -1 && t < 0)
            )
              return this.totalTime(100 * o + t, e, r);
            if (
              ((i = la(v % o)),
              v === m
                ? ((s = this._repeat), (i = g))
                : ((s = ~~(c = la(v / o))) && s === c && ((i = g), s--),
                  g < i && (i = g)),
              (c = wt(this._tTime, o)),
              !_ &&
                this._tTime &&
                c !== s &&
                this._tTime - c * o - this._dur <= 0 &&
                (c = s),
              d && 1 & s && ((i = g - i), (p = 1)),
              s !== c && !this._lock)
            ) {
              var T = d && 1 & c,
                b = T === (d && 1 & s);
              if (
                (s < c && (T = !T),
                (_ = T ? 0 : v % g ? g : v),
                (this._lock = 1),
                (this.render(_ || (p ? 0 : la(s * o)), e, !g)._lock = 0),
                (this._tTime = v),
                !e && this.parent && At(this, 'onRepeat'),
                this.vars.repeatRefresh &&
                  !p &&
                  ((this.invalidate()._lock = 1), (c = s)),
                (_ && _ !== this._time) ||
                  u != !this._ts ||
                  (this.vars.onRepeat && !this.parent && !this._act))
              )
                return this;
              if (
                ((g = this._dur),
                (m = this._tDur),
                b &&
                  ((this._lock = 2),
                  (_ = T ? g : -1e-4),
                  this.render(_, !0),
                  this.vars.repeatRefresh && !p && this.invalidate()),
                (this._lock = 0),
                !this._ts && !u)
              )
                return this;
            }
          }
          if (
            (this._hasPause &&
              !this._forcing &&
              this._lock < 2 &&
              (h = (function _findNextPauseTween(t, e, r) {
                var i;
                if (e < r)
                  for (i = t._first; i && i._start <= r; ) {
                    if ('isPause' === i.data && i._start > e) return i;
                    i = i._next;
                  }
                else
                  for (i = t._last; i && i._start >= r; ) {
                    if ('isPause' === i.data && i._start < e) return i;
                    i = i._prev;
                  }
              })(this, la(_), la(i))) &&
              (v -= i - (i = h._start)),
            (this._tTime = v),
            (this._time = i),
            (this._act = !!l),
            this._initted ||
              ((this._onUpdate = this.vars.onUpdate),
              (this._initted = 1),
              (this._zTime = t),
              (_ = 0)),
            !_ &&
              v &&
              g &&
              !e &&
              !c &&
              (At(this, 'onStart'), this._tTime !== v))
          )
            return this;
          if (_ <= i && 0 <= t)
            for (n = this._first; n; ) {
              if (
                ((a = n._next), (n._act || i >= n._start) && n._ts && h !== n)
              ) {
                if (n.parent !== this) return this.render(t, e, r);
                if (
                  (n.render(
                    0 < n._ts
                      ? (i - n._start) * n._ts
                      : (n._dirty ? n.totalDuration() : n._tDur) +
                          (i - n._start) * n._ts,
                    e,
                    r
                  ),
                  i !== this._time || (!this._ts && !u))
                ) {
                  ((h = 0), a && (v += this._zTime = -q));
                  break;
                }
              }
              n = a;
            }
          else {
            n = this._last;
            for (var w = t < 0 ? t : i; n; ) {
              if (
                ((a = n._prev), (n._act || w <= n._end) && n._ts && h !== n)
              ) {
                if (n.parent !== this) return this.render(t, e, r);
                if (
                  (n.render(
                    0 < n._ts
                      ? (w - n._start) * n._ts
                      : (n._dirty ? n.totalDuration() : n._tDur) +
                          (w - n._start) * n._ts,
                    e,
                    r || (I && pa(n))
                  ),
                  i !== this._time || (!this._ts && !u))
                ) {
                  ((h = 0), a && (v += this._zTime = w ? -q : q));
                  break;
                }
              }
              n = a;
            }
          }
          if (
            h &&
            !e &&
            (this.pause(),
            (h.render(_ <= i ? 0 : -q)._zTime = _ <= i ? 1 : -1),
            this._ts)
          )
            return ((this._start = f), Ka(this), this.render(t, e, r));
          (this._onUpdate && !e && At(this, 'onUpdate', !0),
            ((v === m && this._tTime >= this.totalDuration()) || (!v && _)) &&
              ((f !== this._start && Math.abs(l) === Math.abs(this._ts)) ||
                this._lock ||
                ((!t && g) ||
                  !((v === m && 0 < this._ts) || (!v && this._ts < 0)) ||
                  Ca(this, 1),
                e ||
                  (t < 0 && !_) ||
                  (!v && !_ && m) ||
                  (At(
                    this,
                    v === m && 0 <= t ? 'onComplete' : 'onReverseComplete',
                    !0
                  ),
                  !this._prom ||
                    (v < m && 0 < this.timeScale()) ||
                    this._prom()))));
        }
        return this;
      }),
      (e.add = function add(e, i) {
        var n = this;
        if ((t(i) || (i = Ot(this, i, e)), !(e instanceof qt))) {
          if (K(e))
            return (
              e.forEach(function (t) {
                return n.add(t, i);
              }),
              this
            );
          if (r(e)) return this.addLabel(e, i);
          if (!s(e)) return this;
          e = te.delayedCall(0, e);
        }
        return this !== e ? Na(this, e, i) : this;
      }),
      (e.getChildren = function getChildren(t, e, r, i) {
        (void 0 === t && (t = !0),
          void 0 === e && (e = !0),
          void 0 === r && (r = !0),
          void 0 === i && (i = -X));
        for (var n = [], a = this._first; a; )
          (a._start >= i &&
            (a instanceof te
              ? e && n.push(a)
              : (r && n.push(a),
                t && n.push.apply(n, a.getChildren(!0, e, r)))),
            (a = a._next));
        return n;
      }),
      (e.getById = function getById(t) {
        for (var e = this.getChildren(1, 1, 1), r = e.length; r--; )
          if (e[r].vars.id === t) return e[r];
      }),
      (e.remove = function remove(t) {
        return r(t)
          ? this.removeLabel(t)
          : s(t)
            ? this.killTweensOf(t)
            : (t.parent === this && Ba(this, t),
              t === this._recent && (this._recent = this._last),
              Da(this));
      }),
      (e.totalTime = function totalTime(t, e) {
        return arguments.length
          ? ((this._forcing = 1),
            !this._dp &&
              this._ts &&
              (this._start = la(
                It.time -
                  (0 < this._ts
                    ? t / this._ts
                    : (this.totalDuration() - t) / -this._ts)
              )),
            i.prototype.totalTime.call(this, t, e),
            (this._forcing = 0),
            this)
          : this._tTime;
      }),
      (e.addLabel = function addLabel(t, e) {
        return ((this.labels[t] = Ot(this, e)), this);
      }),
      (e.removeLabel = function removeLabel(t) {
        return (delete this.labels[t], this);
      }),
      (e.addPause = function addPause(t, e, r) {
        var i = te.delayedCall(0, e || V, r);
        return (
          (i.data = 'isPause'),
          (this._hasPause = 1),
          Na(this, i, Ot(this, t))
        );
      }),
      (e.removePause = function removePause(t) {
        var e = this._first;
        for (t = Ot(this, t); e; )
          (e._start === t && 'isPause' === e.data && Ca(e), (e = e._next));
      }),
      (e.killTweensOf = function killTweensOf(t, e, r) {
        for (var i = this.getTweensOf(t, r), n = i.length; n--; )
          Zt !== i[n] && i[n].kill(t, e);
        return this;
      }),
      (e.getTweensOf = function getTweensOf(e, r) {
        for (var i, n = [], a = Pt(e), s = this._first, o = t(r); s; )
          (s instanceof te
            ? na(s._targets, a) &&
              (o
                ? (!Zt || (s._initted && s._ts)) &&
                  s.globalTime(0) <= r &&
                  s.globalTime(s.totalDuration()) > r
                : !r || s.isActive()) &&
              n.push(s)
            : (i = s.getTweensOf(a, r)).length && n.push.apply(n, i),
            (s = s._next));
        return n;
      }),
      (e.tweenTo = function tweenTo(t, e) {
        e = e || {};
        var r,
          i = this,
          n = Ot(i, t),
          a = e.startAt,
          s = e.onStart,
          o = e.onStartParams,
          u = e.immediateRender,
          h = te.to(
            i,
            ta(
              {
                ease: e.ease || 'none',
                lazy: !1,
                immediateRender: !1,
                time: n,
                overwrite: 'auto',
                duration:
                  e.duration ||
                  Math.abs(
                    (n - (a && 'time' in a ? a.time : i._time)) / i.timeScale()
                  ) ||
                  q,
                onStart: function onStart() {
                  if ((i.pause(), !r)) {
                    var t =
                      e.duration ||
                      Math.abs(
                        (n - (a && 'time' in a ? a.time : i._time)) /
                          i.timeScale()
                      );
                    (h._dur !== t && Ua(h, t, 0, 1).render(h._time, !0, !0),
                      (r = 1));
                  }
                  s && s.apply(h, o || []);
                },
              },
              e
            )
          );
        return u ? h.render(0) : h;
      }),
      (e.tweenFromTo = function tweenFromTo(t, e, r) {
        return this.tweenTo(e, ta({ startAt: { time: Ot(this, t) } }, r));
      }),
      (e.recent = function recent() {
        return this._recent;
      }),
      (e.nextLabel = function nextLabel(t) {
        return (void 0 === t && (t = this._time), ub(this, Ot(this, t)));
      }),
      (e.previousLabel = function previousLabel(t) {
        return (void 0 === t && (t = this._time), ub(this, Ot(this, t), 1));
      }),
      (e.currentLabel = function currentLabel(t) {
        return arguments.length
          ? this.seek(t, !0)
          : this.previousLabel(this._time + q);
      }),
      (e.shiftChildren = function shiftChildren(t, e, r) {
        void 0 === r && (r = 0);
        var i,
          n = this._first,
          a = this.labels;
        for (t = la(t); n; )
          (n._start >= r && ((n._start += t), (n._end += t)), (n = n._next));
        if (e) for (i in a) a[i] >= r && (a[i] += t);
        return Da(this);
      }),
      (e.invalidate = function invalidate(t) {
        var e = this._first;
        for (this._lock = 0; e; ) (e.invalidate(t), (e = e._next));
        return i.prototype.invalidate.call(this, t);
      }),
      (e.clear = function clear(t) {
        void 0 === t && (t = !0);
        for (var e, r = this._first; r; )
          ((e = r._next), this.remove(r), (r = e));
        return (
          this._dp && (this._time = this._tTime = this._pTime = 0),
          t && (this.labels = {}),
          Da(this)
        );
      }),
      (e.totalDuration = function totalDuration(t) {
        var e,
          r,
          i,
          n = 0,
          a = this,
          s = a._last,
          o = X;
        if (arguments.length)
          return a.timeScale(
            (a._repeat < 0 ? a.duration() : a.totalDuration()) /
              (a.reversed() ? -t : t)
          );
        if (a._dirty) {
          for (i = a.parent; s; )
            ((e = s._prev),
              s._dirty && s.totalDuration(),
              o < (r = s._start) && a._sort && s._ts && !a._lock
                ? ((a._lock = 1), (Na(a, s, r - s._delay, 1)._lock = 0))
                : (o = r),
              r < 0 &&
                s._ts &&
                ((n -= r),
                ((!i && !a._dp) || (i && i.smoothChildTiming)) &&
                  ((a._start += la(r / a._ts)),
                  (a._time -= r),
                  (a._tTime -= r)),
                a.shiftChildren(-r, !1, -Infinity),
                (o = 0)),
              s._end > n && s._ts && (n = s._end),
              (s = e));
          (Ua(a, a === L && a._time > n ? a._time : n, 1, 1), (a._dirty = 0));
        }
        return a._tDur;
      }),
      (Timeline.updateRoot = function updateRoot(t) {
        if ((L._ts && (qa(L, Ja(t, L)), (f = It.frame)), It.frame >= vt)) {
          vt += Y.autoSleep || 120;
          var e = L._first;
          if ((!e || !e._ts) && Y.autoSleep && It._listeners.length < 2) {
            for (; e && !e._ts; ) e = e._next;
            e || It.sleep();
          }
        }
      }),
      Timeline
    );
  })(qt);
  ta(Gt.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
  function cc(t, e, i, n, a, o) {
    var u, h, l, f;
    if (
      mt[t] &&
      !1 !==
        (u = new mt[t]()).init(
          a,
          u.rawVars
            ? e[t]
            : (function _processVars(t, e, i, n, a) {
                if (
                  (s(t) && (t = Qt(t, a, e, i, n)),
                  !v(t) || (t.style && t.nodeType) || K(t) || J(t))
                )
                  return r(t) ? Qt(t, a, e, i, n) : t;
                var o,
                  u = {};
                for (o in t) u[o] = Qt(t[o], a, e, i, n);
                return u;
              })(e[t], n, a, o, i),
          i,
          n,
          o
        ) &&
      ((i._pt = h = new we(i._pt, a, t, 0, 1, u.render, u, 0, u.priority)),
      i !== c)
    )
      for (l = i._ptLookup[i._targets.indexOf(a)], f = u._props.length; f--; )
        l[u._props[f]] = h;
    return u;
  }
  function ic(t, r, e, i) {
    var n,
      a,
      s = r.ease || i || 'power1.inOut';
    if (K(r))
      ((a = e[t] || (e[t] = [])),
        r.forEach(function (t, e) {
          return a.push({ t: (e / (r.length - 1)) * 100, v: t, e: s });
        }));
    else
      for (n in r)
        ((a = e[n] || (e[n] = [])),
          'ease' === n || a.push({ t: parseFloat(t), v: r[n], e: s }));
  }
  var Zt,
    Wt,
    $t = function _addPropTween(t, e, i, n, a, o, u, h, l, f) {
      s(n) && (n = n(a || 0, t, o));
      var c,
        d = t[e],
        p =
          'get' !== i
            ? i
            : s(d)
              ? l
                ? t[
                    e.indexOf('set') || !s(t['get' + e.substr(3)])
                      ? e
                      : 'get' + e.substr(3)
                  ](l)
                : t[e]()
              : d,
        _ = s(d) ? (l ? se : ae) : ie;
      if (
        (r(n) &&
          (~n.indexOf('random(') && (n = rb(n)),
          '=' === n.charAt(1) &&
            ((!(c = ma(p, n) + (_a(p) || 0)) && 0 !== c) || (n = c))),
        !f || p !== n || Wt)
      )
        return isNaN(p * n) || '' === n
          ? (d || e in t || S(e, n),
            function _addComplexStringPropTween(t, e, r, i, n, a, s) {
              var o,
                u,
                h,
                l,
                f,
                c,
                d,
                p,
                _ = new we(this._pt, t, e, 0, 1, pe, null, n),
                m = 0,
                g = 0;
              for (
                _.b = r,
                  _.e = i,
                  r += '',
                  (d = ~(i += '').indexOf('random(')) && (i = rb(i)),
                  a && (a((p = [r, i]), t, e), (r = p[0]), (i = p[1])),
                  u = r.match(at) || [];
                (o = at.exec(i));
              )
                ((l = o[0]),
                  (f = i.substring(m, o.index)),
                  h ? (h = (h + 1) % 5) : 'rgba(' === f.substr(-5) && (h = 1),
                  l !== u[g++] &&
                    ((c = parseFloat(u[g - 1]) || 0),
                    (_._pt = {
                      _next: _._pt,
                      p: f || 1 === g ? f : ',',
                      s: c,
                      c: '=' === l.charAt(1) ? ma(c, l) - c : parseFloat(l) - c,
                      m: h && h < 4 ? Math.round : 0,
                    }),
                    (m = at.lastIndex)));
              return (
                (_.c = m < i.length ? i.substring(m, i.length) : ''),
                (_.fp = s),
                (st.test(i) || d) && (_.e = 0),
                (this._pt = _)
              );
            }.call(this, t, e, p, n, _, h || Y.stringFilter, l))
          : ((c = new we(
              this._pt,
              t,
              e,
              +p || 0,
              n - (p || 0),
              'boolean' == typeof d ? de : fe,
              0,
              _
            )),
            l && (c.fp = l),
            u && c.modifier(u, this, t),
            (this._pt = c));
    },
    Ht = function _initTween(t, e, r) {
      var i,
        n,
        a,
        s,
        o,
        u,
        h,
        l,
        f,
        c,
        d,
        p,
        _,
        m = t.vars,
        g = m.ease,
        v = m.startAt,
        y = m.immediateRender,
        T = m.lazy,
        b = m.onUpdate,
        x = m.runBackwards,
        k = m.yoyoEase,
        O = m.keyframes,
        M = m.autoRevert,
        C = t._dur,
        P = t._startAt,
        S = t._targets,
        A = t.parent,
        D = A && 'nested' === A.data ? A.vars.targets : S,
        z = 'auto' === t._overwrite && !F,
        R = t.timeline,
        E = m.easeReverse || k;
      if (
        (!R || (O && g) || (g = 'none'),
        (t._ease = jt(g, j.ease)),
        (t._rEase = E && (jt(E) || t._ease)),
        (t._from = !R && !!m.runBackwards),
        t._from && (t.ratio = 1),
        !R || (O && !m.stagger))
      ) {
        if (
          ((p = (l = S[0] ? ha(S[0]).harness : 0) && m[l.prop]),
          (i = xa(m, dt)),
          P &&
            (P._zTime < 0 && P.progress(1),
            e < 0 && x && y && !M
              ? P.render(-1, !0)
              : P.revert(x && C ? ft : lt),
            (P._lazy = 0)),
          v)
        ) {
          if (
            (Ca(
              (t._startAt = te.set(
                S,
                ta(
                  {
                    data: 'isStart',
                    overwrite: !1,
                    parent: A,
                    immediateRender: !0,
                    lazy: !P && w(T),
                    startAt: null,
                    delay: 0,
                    onUpdate:
                      b &&
                      function () {
                        return At(t, 'onUpdate');
                      },
                    stagger: 0,
                  },
                  v
                )
              ))
            ),
            (t._startAt._dp = 0),
            (t._startAt._sat = t),
            e < 0 && (I || (!y && !M)) && t._startAt.revert(ft),
            y && C && e <= 0 && r <= 0)
          )
            return void (e && (t._zTime = e));
        } else if (x && C && !P)
          if (
            (e && (y = !1),
            (a = ta(
              {
                overwrite: !1,
                data: 'isFromStart',
                lazy: y && !P && w(T),
                immediateRender: y,
                stagger: 0,
                parent: A,
              },
              i
            )),
            p && (a[l.prop] = p),
            Ca((t._startAt = te.set(S, a))),
            (t._startAt._dp = 0),
            (t._startAt._sat = t),
            e < 0 && (I ? t._startAt.revert(ft) : t._startAt.render(-1, !0)),
            (t._zTime = e),
            y)
          ) {
            if (!e) return;
          } else _initTween(t._startAt, q, q);
        for (
          t._pt = t._ptCache = 0, T = (C && w(T)) || (T && !C), n = 0;
          n < S.length;
          n++
        ) {
          if (
            ((h = (o = S[n])._gsap || ga(S)[n]._gsap),
            (t._ptLookup[n] = c = {}),
            _t[h.id] && pt.length && oa(),
            (d = D === S ? n : D.indexOf(o)),
            l &&
              !1 !== (f = new l()).init(o, p || i, t, d, D) &&
              ((t._pt = s =
                new we(t._pt, o, f.name, 0, 1, f.render, f, 0, f.priority)),
              f._props.forEach(function (t) {
                c[t] = s;
              }),
              f.priority && (u = 1)),
            !l || p)
          )
            for (a in i)
              mt[a] && (f = cc(a, i, t, d, o, D))
                ? f.priority && (u = 1)
                : (c[a] = s =
                    $t.call(t, o, a, 'get', i[a], d, D, 0, m.stringFilter));
          (t._op && t._op[n] && t.kill(o, t._op[n]),
            z &&
              t._pt &&
              ((Zt = t),
              L.killTweensOf(o, c, t.globalTime(e)),
              (_ = !t.parent),
              (Zt = 0)),
            t._pt && T && (_t[h.id] = 1));
        }
        (u && be(t), t._onInit && t._onInit(t));
      }
      ((t._onUpdate = b),
        (t._initted = (!t._op || t._pt) && !_),
        O && e <= 0 && R.render(X, !0, !0));
    },
    Qt = function _parseFuncOrString(t, e, i, n, a) {
      return s(t)
        ? t.call(e, i, n, a)
        : r(t) && ~t.indexOf('random(')
          ? rb(t)
          : t;
    },
    Jt =
      Tt +
      'repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert',
    Kt = {};
  ja(Jt + ',id,stagger,delay,duration,paused,scrollTrigger', function (t) {
    return (Kt[t] = 1);
  });
  var te = (function (E) {
    function Tween(e, r, i, n) {
      var a;
      'number' == typeof r && ((i.duration = r), (r = i), (i = null));
      var s,
        o,
        u,
        h,
        l,
        f,
        c,
        d,
        p = (a = E.call(this, n ? r : ya(r)) || this).vars,
        _ = p.duration,
        m = p.delay,
        g = p.immediateRender,
        b = p.stagger,
        x = p.overwrite,
        k = p.keyframes,
        O = p.defaults,
        M = p.scrollTrigger,
        C = r.parent || L,
        P = (K(e) || J(e) ? t(e[0]) : 'length' in r) ? [e] : Pt(e);
      if (
        ((a._targets = P.length
          ? ga(P)
          : T(
              'GSAP target ' + e + ' not found. https://gsap.com',
              !Y.nullTargetWarn
            ) || []),
        (a._ptLookup = []),
        (a._overwrite = x),
        k || b || y(_) || y(m))
      ) {
        var S = (r = a.vars).easeReverse || r.yoyoEase;
        if (
          ((s = a.timeline =
            new Gt({
              data: 'nested',
              defaults: O || {},
              targets: C && 'nested' === C.data ? C.vars.targets : P,
            })).kill(),
          (s.parent = s._dp = _assertThisInitialized(a)),
          (s._start = 0),
          b || y(_) || y(m))
        ) {
          if (((h = P.length), (c = b && hb(b)), v(b)))
            for (l in b) ~Jt.indexOf(l) && ((d = d || {})[l] = b[l]);
          for (o = 0; o < h; o++)
            (((u = xa(r, Kt)).stagger = 0),
              S && (u.easeReverse = S),
              d && bt(u, d),
              (f = P[o]),
              (u.duration = +Qt(_, _assertThisInitialized(a), o, f, P)),
              (u.delay =
                (+Qt(m, _assertThisInitialized(a), o, f, P) || 0) - a._delay),
              !b &&
                1 === h &&
                u.delay &&
                ((a._delay = m = u.delay), (a._start += m), (u.delay = 0)),
              s.to(f, u, c ? c(o, f, P) : 0),
              (s._ease = Bt.none));
          s.duration() ? (_ = m = 0) : (a.timeline = 0);
        } else if (k) {
          (ya(ta(s.vars.defaults, { ease: 'none' })),
            (s._ease = jt(k.ease || r.ease || 'none')));
          var A,
            D,
            z,
            R = 0;
          if (K(k))
            (k.forEach(function (t) {
              return s.to(P, t, '>');
            }),
              s.duration());
          else {
            for (l in ((u = {}), k))
              'ease' === l || 'easeEach' === l || ic(l, k[l], u, k.easeEach);
            for (l in u)
              for (
                A = u[l].sort(function (t, e) {
                  return t.t - e.t;
                }),
                  o = R = 0;
                o < A.length;
                o++
              )
                (((z = {
                  ease: (D = A[o]).e,
                  duration: ((D.t - (o ? A[o - 1].t : 0)) / 100) * _,
                })[l] = D.v),
                  s.to(P, z, R),
                  (R += z.duration));
            s.duration() < _ && s.to({}, { duration: _ - s.duration() });
          }
        }
        _ || a.duration((_ = s.duration()));
      } else a.timeline = 0;
      return (
        !0 !== x ||
          F ||
          ((Zt = _assertThisInitialized(a)), L.killTweensOf(P), (Zt = 0)),
        Na(C, _assertThisInitialized(a), i),
        r.reversed && a.reverse(),
        r.paused && a.paused(!0),
        (g ||
          (!_ &&
            !k &&
            a._start === la(C._time) &&
            w(g) &&
            (function _hasNoPausedAncestors(t) {
              return !t || (t._ts && _hasNoPausedAncestors(t.parent));
            })(_assertThisInitialized(a)) &&
            'nested' !== C.data)) &&
          ((a._tTime = -q), a.render(Math.max(0, -m) || 0)),
        M && Oa(_assertThisInitialized(a), M),
        a
      );
    }
    _inheritsLoose(Tween, E);
    var e = Tween.prototype;
    return (
      (e.render = function render(t, e, r) {
        var i,
          n,
          a,
          s,
          o,
          u,
          h,
          l,
          f = this._time,
          c = this._tDur,
          d = this._dur,
          p = t < 0,
          _ = c - q < t && !p ? c : t < q ? 0 : t;
        if (d) {
          if (
            _ !== this._tTime ||
            !t ||
            r ||
            (!this._initted && this._tTime) ||
            (this._startAt && this._zTime < 0 != p) ||
            this._lazy
          ) {
            if (((i = _), (l = this.timeline), this._repeat)) {
              if (((s = d + this._rDelay), this._repeat < -1 && p))
                return this.totalTime(100 * s + t, e, r);
              if (
                ((i = la(_ % s)),
                _ === c
                  ? ((a = this._repeat), (i = d))
                  : (a = ~~(o = la(_ / s))) && a === o
                    ? ((i = d), a--)
                    : d < i && (i = d),
                (u = this._yoyo && 1 & a) && (i = d - i),
                (o = wt(this._tTime, s)),
                i === f && !r && this._initted && a === o)
              )
                return ((this._tTime = _), this);
              a !== o &&
                this.vars.repeatRefresh &&
                !u &&
                !this._lock &&
                i !== s &&
                this._initted &&
                ((this._lock = r = 1),
                (this.render(la(s * a), !0).invalidate()._lock = 0));
            }
            if (!this._initted) {
              if (Pa(this, p ? t : i, r, e, _))
                return ((this._tTime = 0), this);
              if (
                !(f === this._time || (r && this.vars.repeatRefresh && a !== o))
              )
                return this;
              if (d !== this._dur) return this.render(t, e, r);
            }
            if (this._rEase) {
              var m = i < f;
              if (m !== this._inv) {
                var g = m ? f : d - f;
                ((this._inv = m),
                  this._from && (this.ratio = 1 - this.ratio),
                  (this._invRatio = this.ratio),
                  (this._invTime = f),
                  (this._invRecip = g ? (m ? -1 : 1) / g : 0),
                  (this._invScale = m ? -this.ratio : 1 - this.ratio),
                  (this._invEase = m ? this._rEase : this._ease));
              }
              this.ratio = h =
                this._invRatio +
                this._invScale *
                  this._invEase((i - this._invTime) * this._invRecip);
            } else this.ratio = h = this._ease(i / d);
            if (
              (this._from && (this.ratio = h = 1 - h),
              (this._tTime = _),
              (this._time = i),
              !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
              !f && _ && !e && !o && (At(this, 'onStart'), this._tTime !== _))
            )
              return this;
            for (n = this._pt; n; ) (n.r(h, n.d), (n = n._next));
            ((l &&
              l.render(t < 0 ? t : l._dur * l._ease(i / this._dur), e, r)) ||
              (this._startAt && (this._zTime = t)),
              this._onUpdate &&
                !e &&
                (p && Fa(this, t, 0, r), At(this, 'onUpdate')),
              this._repeat &&
                a !== o &&
                this.vars.onRepeat &&
                !e &&
                this.parent &&
                At(this, 'onRepeat'),
              (_ !== this._tDur && _) ||
                this._tTime !== _ ||
                (p && !this._onUpdate && Fa(this, t, 0, !0),
                (!t && d) ||
                  !(
                    (_ === this._tDur && 0 < this._ts) ||
                    (!_ && this._ts < 0)
                  ) ||
                  Ca(this, 1),
                e ||
                  (p && !f) ||
                  !(_ || f || u) ||
                  (At(this, _ === c ? 'onComplete' : 'onReverseComplete', !0),
                  !this._prom ||
                    (_ < c && 0 < this.timeScale()) ||
                    this._prom())));
          }
        } else
          !(function _renderZeroDurationTween(t, e, r, i) {
            var n,
              a,
              s,
              o = t.ratio,
              u =
                e < 0 ||
                (!e &&
                  ((!t._start &&
                    (function _parentPlayheadIsBeforeStart(t) {
                      var e = t.parent;
                      return (
                        e &&
                        e._ts &&
                        e._initted &&
                        !e._lock &&
                        (e.rawTime() < 0 || _parentPlayheadIsBeforeStart(e))
                      );
                    })(t) &&
                    (t._initted || !xt(t))) ||
                    ((t._ts < 0 || t._dp._ts < 0) && !xt(t))))
                  ? 0
                  : 1,
              h = t._rDelay,
              l = 0;
            if (
              (h &&
                t._repeat &&
                ((l = Mt(0, t._tDur, e)),
                (a = wt(l, h)),
                t._yoyo && 1 & a && (u = 1 - u),
                a !== wt(t._tTime, h) &&
                  ((o = 1 - u),
                  t.vars.repeatRefresh && t._initted && t.invalidate())),
              u !== o || I || i || t._zTime === q || (!e && t._zTime))
            ) {
              if (!t._initted && Pa(t, e, i, r, l)) return;
              for (
                s = t._zTime,
                  t._zTime = e || (r ? q : 0),
                  r = r || (e && !s),
                  t.ratio = u,
                  t._from && (u = 1 - u),
                  t._time = 0,
                  t._tTime = l,
                  n = t._pt;
                n;
              )
                (n.r(u, n.d), (n = n._next));
              (e < 0 && Fa(t, e, 0, !0),
                t._onUpdate && !r && At(t, 'onUpdate'),
                l && t._repeat && !r && t.parent && At(t, 'onRepeat'),
                (e >= t._tDur || e < 0) &&
                  t.ratio === u &&
                  (u && Ca(t, 1),
                  r ||
                    I ||
                    (At(t, u ? 'onComplete' : 'onReverseComplete', !0),
                    t._prom && t._prom())));
            } else t._zTime || (t._zTime = e);
          })(this, t, e, r);
        return this;
      }),
      (e.targets = function targets() {
        return this._targets;
      }),
      (e.invalidate = function invalidate(t) {
        return (
          (t && this.vars.runBackwards) || (this._startAt = 0),
          (this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0),
          (this._ptLookup = []),
          this.timeline && this.timeline.invalidate(t),
          E.prototype.invalidate.call(this, t)
        );
      }),
      (e.resetTo = function resetTo(t, e, r, i, n) {
        (d || It.wake(), this._ts || this.play());
        var a,
          s = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
        return (
          this._initted || Ht(this, s),
          (a = this._ease(s / this._dur)),
          (function _updatePropTweens(t, e, r, i, n, a, s, o) {
            var u,
              h,
              l,
              f,
              c = ((t._pt && t._ptCache) || (t._ptCache = {}))[e];
            if (!c)
              for (
                c = t._ptCache[e] = [], l = t._ptLookup, f = t._targets.length;
                f--;
              ) {
                if ((u = l[f][e]) && u.d && u.d._pt)
                  for (u = u.d._pt; u && u.p !== e && u.fp !== e; ) u = u._next;
                if (!u)
                  return (
                    (Wt = 1),
                    (t.vars[e] = '+=0'),
                    Ht(t, s),
                    (Wt = 0),
                    o
                      ? T(
                          e +
                            ' not eligible for reset. Try splitting into individual properties'
                        )
                      : 1
                  );
                c.push(u);
              }
            for (f = c.length; f--; )
              (((u = (h = c[f])._pt || h).s =
                (!i && 0 !== i) || n ? u.s + (i || 0) + a * u.c : i),
                (u.c = r - u.s),
                h.e && (h.e = ka(r) + _a(h.e)),
                h.b && (h.b = u.s + _a(h.b)));
          })(this, t, e, r, i, a, s, n)
            ? this.resetTo(t, e, r, i, 1)
            : (La(this, 0),
              this.parent ||
                Aa(
                  this._dp,
                  this,
                  '_first',
                  '_last',
                  this._dp._sort ? '_start' : 0
                ),
              this.render(0))
        );
      }),
      (e.kill = function kill(t, e) {
        if ((void 0 === e && (e = 'all'), !(t || (e && 'all' !== e))))
          return (
            (this._lazy = this._pt = 0),
            this.parent
              ? wb(this)
              : this.scrollTrigger && this.scrollTrigger.kill(!!I),
            this
          );
        if (this.timeline) {
          var i = this.timeline.totalDuration();
          return (
            this.timeline.killTweensOf(t, e, Zt && !0 !== Zt.vars.overwrite)
              ._first || wb(this),
            this.parent &&
              i !== this.timeline.totalDuration() &&
              Ua(this, (this._dur * this.timeline._tDur) / i, 0, 1),
            this
          );
        }
        var n,
          a,
          s,
          o,
          u,
          h,
          l,
          f = this._targets,
          c = t ? Pt(t) : f,
          d = this._ptLookup,
          p = this._pt;
        if (
          (!e || 'all' === e) &&
          (function _arraysMatch(t, e) {
            for (
              var r = t.length, i = r === e.length;
              i && r-- && t[r] === e[r];
            );
            return r < 0;
          })(f, c)
        )
          return ('all' === e && (this._pt = 0), wb(this));
        for (
          n = this._op = this._op || [],
            'all' !== e &&
              (r(e) &&
                ((u = {}),
                ja(e, function (t) {
                  return (u[t] = 1);
                }),
                (e = u)),
              (e = (function _addAliasesToVars(t, e) {
                var r,
                  i,
                  n,
                  a,
                  s = t[0] ? ha(t[0]).harness : 0,
                  o = s && s.aliases;
                if (!o) return e;
                for (i in ((r = bt({}, e)), o))
                  if ((i in r))
                    for (n = (a = o[i].split(',')).length; n--; )
                      r[a[n]] = r[i];
                return r;
              })(f, e))),
            l = f.length;
          l--;
        )
          if (~c.indexOf(f[l]))
            for (u in ((a = d[l]),
            'all' === e
              ? ((n[l] = e), (o = a), (s = {}))
              : ((s = n[l] = n[l] || {}), (o = e)),
            o))
              ((h = a && a[u]) &&
                (('kill' in h.d && !0 !== h.d.kill(u)) || Ba(this, h, '_pt'),
                delete a[u]),
                'all' !== s && (s[u] = 1));
        return (this._initted && !this._pt && p && wb(this), this);
      }),
      (Tween.to = function to(t, e, r) {
        return new Tween(t, e, r);
      }),
      (Tween.from = function from(t, e) {
        return Ya(1, arguments);
      }),
      (Tween.delayedCall = function delayedCall(t, e, r, i) {
        return new Tween(e, 0, {
          immediateRender: !1,
          lazy: !1,
          overwrite: !1,
          delay: t,
          onComplete: e,
          onReverseComplete: e,
          onCompleteParams: r,
          onReverseCompleteParams: r,
          callbackScope: i,
        });
      }),
      (Tween.fromTo = function fromTo(t, e, r) {
        return Ya(2, arguments);
      }),
      (Tween.set = function set(t, e) {
        return (
          (e.duration = 0),
          e.repeatDelay || (e.repeat = 0),
          new Tween(t, e)
        );
      }),
      (Tween.killTweensOf = function killTweensOf(t, e, r) {
        return L.killTweensOf(t, e, r);
      }),
      Tween
    );
  })(qt);
  (ta(te.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0,
  }),
    ja('staggerTo,staggerFrom,staggerFromTo', function (r) {
      te[r] = function () {
        var t = new Gt(),
          e = Ct.call(arguments, 0);
        return (
          e.splice('staggerFromTo' === r ? 5 : 4, 0, 0),
          t[r].apply(t, e)
        );
      };
    }));
  function qc(t, e, r) {
    return t.setAttribute(e, r);
  }
  function yc(t, e, r, i) {
    i.mSet(t, e, i.m.call(i.tween, r, i.mt), i);
  }
  var ie = function _setterPlain(t, e, r) {
      return (t[e] = r);
    },
    ae = function _setterFunc(t, e, r) {
      return t[e](r);
    },
    se = function _setterFuncWithParam(t, e, r, i) {
      return t[e](i.fp, r);
    },
    ue = function _getSetter(t, e) {
      return s(t[e]) ? ae : u(t[e]) && t.setAttribute ? qc : ie;
    },
    fe = function _renderPlain(t, e) {
      return e.set(e.t, e.p, Math.round(1e6 * (e.s + e.c * t)) / 1e6, e);
    },
    de = function _renderBoolean(t, e) {
      return e.set(e.t, e.p, !!(e.s + e.c * t), e);
    },
    pe = function _renderComplexString(t, e) {
      var r = e._pt,
        i = '';
      if (!t && e.b) i = e.b;
      else if (1 === t && e.e) i = e.e;
      else {
        for (; r; )
          ((i =
            r.p +
            (r.m
              ? r.m(r.s + r.c * t)
              : Math.round(1e4 * (r.s + r.c * t)) / 1e4) +
            i),
            (r = r._next));
        i += e.c;
      }
      e.set(e.t, e.p, i, e);
    },
    _e = function _renderPropTweens(t, e) {
      for (var r = e._pt; r; ) (r.r(t, r.d), (r = r._next));
    },
    ve = function _addPluginModifier(t, e, r, i) {
      for (var n, a = this._pt; a; )
        ((n = a._next), a.p === i && a.modifier(t, e, r), (a = n));
    },
    Te = function _killPropTweensOf(t) {
      for (var e, r, i = this._pt; i; )
        ((r = i._next),
          (i.p === t && !i.op) || i.op === t
            ? Ba(this, i, '_pt')
            : i.dep || (e = 1),
          (i = r));
      return !e;
    },
    be = function _sortPropTweensByPriority(t) {
      for (var e, r, i, n, a = t._pt; a; ) {
        for (e = a._next, r = i; r && r.pr > a.pr; ) r = r._next;
        ((a._prev = r ? r._prev : n) ? (a._prev._next = a) : (i = a),
          (a._next = r) ? (r._prev = a) : (n = a),
          (a = e));
      }
      t._pt = i;
    },
    we =
      ((PropTween.prototype.modifier = function modifier(t, e, r) {
        ((this.mSet = this.mSet || this.set),
          (this.set = yc),
          (this.m = t),
          (this.mt = r),
          (this.tween = e));
      }),
      PropTween);
  function PropTween(t, e, r, i, n, a, s, o, u) {
    ((this.t = e),
      (this.s = i),
      (this.c = n),
      (this.p = r),
      (this.r = a || fe),
      (this.d = s || this),
      (this.set = o || ie),
      (this.pr = u || 0),
      (this._next = t) && (t._prev = this));
  }
  (ja(
    Tt +
      'parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse',
    function (t) {
      return (dt[t] = 1);
    }
  ),
    (ht.TweenMax = ht.TweenLite = te),
    (ht.TimelineLite = ht.TimelineMax = Gt),
    (L = new Gt({
      sortChildren: !1,
      defaults: j,
      autoRemoveChildren: !0,
      id: 'root',
      smoothChildTiming: !0,
    })),
    (Y.stringFilter = Ib));
  function Gc(t) {
    return (Oe[t] || Me).map(function (t) {
      return t();
    });
  }
  function Hc() {
    var t = Date.now(),
      o = [];
    2 < t - Ce &&
      (Gc('matchMediaInit'),
      ke.forEach(function (t) {
        var e,
          r,
          i,
          n,
          a = t.queries,
          s = t.conditions;
        for (r in a)
          ((e = h.matchMedia(a[r]).matches) && (i = 1),
            e !== s[r] && ((s[r] = e), (n = 1)));
        n && (t.revert(), i && o.push(t));
      }),
      Gc('matchMediaRevert'),
      o.forEach(function (e) {
        return e.onMatch(e, function (t) {
          return e.add(null, t);
        });
      }),
      (Ce = t),
      Gc('matchMedia'));
  }
  var xe,
    ke = [],
    Oe = {},
    Me = [],
    Ce = 0,
    Pe = 0,
    Se =
      (((xe = Context.prototype).add = function add(t, i, n) {
        function Gw() {
          var t,
            e = l,
            r = a.selector;
          return (
            e && e !== a && e.data.push(a),
            n && (a.selector = fb(n)),
            (l = a),
            (t = i.apply(a, arguments)),
            s(t) && a._r.push(t),
            (l = e),
            (a.selector = r),
            (a.isReverted = !1),
            t
          );
        }
        s(t) && ((n = i), (i = t), (t = s));
        var a = this;
        return (
          (a.last = Gw),
          t === s
            ? Gw(a, function (t) {
                return a.add(null, t);
              })
            : t
              ? (a[t] = Gw)
              : Gw
        );
      }),
      (xe.ignore = function ignore(t) {
        var e = l;
        ((l = null), t(this), (l = e));
      }),
      (xe.getTweens = function getTweens() {
        var e = [];
        return (
          this.data.forEach(function (t) {
            return t instanceof Context
              ? e.push.apply(e, t.getTweens())
              : t instanceof te &&
                  !(t.parent && 'nested' === t.parent.data) &&
                  e.push(t);
          }),
          e
        );
      }),
      (xe.clear = function clear() {
        this._r.length = this.data.length = 0;
      }),
      (xe.kill = function kill(i, t) {
        var n = this;
        if (
          (i
            ? (function () {
                for (var t, e = n.getTweens(), r = n.data.length; r--; )
                  'isFlip' === (t = n.data[r]).data &&
                    (t.revert(),
                    t.getChildren(!0, !0, !1).forEach(function (t) {
                      return e.splice(e.indexOf(t), 1);
                    }));
                for (
                  e
                    .map(function (t) {
                      return {
                        g:
                          t._dur ||
                          t._delay ||
                          (t._sat && !t._sat.vars.immediateRender)
                            ? t.globalTime(0)
                            : -1 / 0,
                        t: t,
                      };
                    })
                    .sort(function (t, e) {
                      return e.g - t.g || -1 / 0;
                    })
                    .forEach(function (t) {
                      return t.t.revert(i);
                    }),
                    r = n.data.length;
                  r--;
                )
                  (t = n.data[r]) instanceof Gt
                    ? 'nested' !== t.data &&
                      (t.scrollTrigger && t.scrollTrigger.revert(), t.kill())
                    : t instanceof te || !t.revert || t.revert(i);
                (n._r.forEach(function (t) {
                  return t(i, n);
                }),
                  (n.isReverted = !0));
              })()
            : this.data.forEach(function (t) {
                return t.kill && t.kill();
              }),
          this.clear(),
          t)
        )
          for (var e = ke.length; e--; )
            ke[e].id === this.id && ke.splice(e, 1);
      }),
      (xe.revert = function revert(t) {
        this.kill(t || {});
      }),
      Context);
  function Context(t, e) {
    ((this.selector = e && fb(e)),
      (this.data = []),
      (this._r = []),
      (this.isReverted = !1),
      (this.id = Pe++),
      t && this.add(t));
  }
  var De,
    Re =
      (((De = MatchMedia.prototype).add = function add(t, e, r) {
        v(t) || (t = { matches: t });
        var i,
          n,
          a,
          s = new Se(0, r || this.scope),
          o = (s.conditions = {});
        for (n in (l && !s.selector && (s.selector = l.selector),
        this.contexts.push(s),
        (e = s.add('onMatch', e)),
        (s.queries = t)))
          'all' === n
            ? (a = 1)
            : (i = h.matchMedia(t[n])) &&
              (ke.indexOf(s) < 0 && ke.push(s),
              (o[n] = i.matches) && (a = 1),
              i.addListener
                ? i.addListener(Hc)
                : i.addEventListener('change', Hc));
        return (
          a &&
            e(s, function (t) {
              return s.add(null, t);
            }),
          this
        );
      }),
      (De.revert = function revert(t) {
        this.kill(t || {});
      }),
      (De.kill = function kill(e) {
        this.contexts.forEach(function (t) {
          return t.kill(e, !0);
        });
      }),
      MatchMedia);
  function MatchMedia(t) {
    ((this.contexts = []), (this.scope = t), l && l.data.push(this));
  }
  var Ee = {
    registerPlugin: function registerPlugin() {
      for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
        e[r] = arguments[r];
      e.forEach(function (t) {
        return zb(t);
      });
    },
    timeline: function timeline(t) {
      return new Gt(t);
    },
    getTweensOf: function getTweensOf(t, e) {
      return L.getTweensOf(t, e);
    },
    getProperty: function getProperty(i, t, e, n) {
      r(i) && (i = Pt(i)[0]);
      var a = ha(i || {}).get,
        s = e ? sa : ra;
      return (
        'native' === e && (e = ''),
        i
          ? t
            ? s(((mt[t] && mt[t].get) || a)(i, t, e, n))
            : function (t, e, r) {
                return s(((mt[t] && mt[t].get) || a)(i, t, e, r));
              }
          : i
      );
    },
    quickSetter: function quickSetter(r, e, i) {
      if (1 < (r = Pt(r)).length) {
        var n = r.map(function (t) {
            return Fe.quickSetter(t, e, i);
          }),
          a = n.length;
        return function (t) {
          for (var e = a; e--; ) n[e](t);
        };
      }
      r = r[0] || {};
      var s = mt[e],
        o = ha(r),
        u = (o.harness && (o.harness.aliases || {})[e]) || e,
        h = s
          ? function (t) {
              var e = new s();
              ((c._pt = 0),
                e.init(r, i ? t + i : t, c, 0, [r]),
                e.render(1, e),
                c._pt && _e(1, c));
            }
          : o.set(r, u);
      return s
        ? h
        : function (t) {
            return h(r, u, i ? t + i : t, o, 1);
          };
    },
    quickTo: function quickTo(t, i, e) {
      function $x(t, e, r) {
        return n.resetTo(i, t, e, r);
      }
      var r,
        n = Fe.to(
          t,
          ta(
            (((r = {})[i] = '+=0.1'), (r.paused = !0), (r.stagger = 0), r),
            e || {}
          )
        );
      return (($x.tween = n), $x);
    },
    isTweening: function isTweening(t) {
      return 0 < L.getTweensOf(t, !0).length;
    },
    defaults: function defaults(t) {
      return (t && t.ease && (t.ease = jt(t.ease, j.ease)), wa(j, t || {}));
    },
    config: function config(t) {
      return wa(Y, t || {});
    },
    registerEffect: function registerEffect(t) {
      var i = t.name,
        n = t.effect,
        e = t.plugins,
        a = t.defaults,
        r = t.extendTimeline;
      ((e || '').split(',').forEach(function (t) {
        return (
          t && !mt[t] && !ht[t] && T(i + ' effect requires ' + t + ' plugin.')
        );
      }),
        (gt[i] = function (t, e, r) {
          return n(Pt(t), ta(e || {}, a), r);
        }),
        r &&
          (Gt.prototype[i] = function (t, e, r) {
            return this.add(gt[i](t, v(e) ? e : (r = e) && {}, this), r);
          }));
    },
    registerEase: function registerEase(t, e) {
      Bt[t] = jt(e);
    },
    parseEase: function parseEase(t, e) {
      return arguments.length ? jt(t, e) : Bt;
    },
    getById: function getById(t) {
      return L.getById(t);
    },
    exportRoot: function exportRoot(t, e) {
      void 0 === t && (t = {});
      var r,
        i,
        n = new Gt(t);
      for (
        n.smoothChildTiming = w(t.smoothChildTiming),
          L.remove(n),
          n._dp = 0,
          n._time = n._tTime = L._time,
          r = L._first;
        r;
      )
        ((i = r._next),
          (!e &&
            !r._dur &&
            r instanceof te &&
            r.vars.onComplete === r._targets[0]) ||
            Na(n, r, r._start - r._delay),
          (r = i));
      return (Na(L, n, 0), n);
    },
    context: function context(t, e) {
      return t ? new Se(t, e) : l;
    },
    matchMedia: function matchMedia(t) {
      return new Re(t);
    },
    matchMediaRefresh: function matchMediaRefresh() {
      return (
        ke.forEach(function (t) {
          var e,
            r,
            i = t.conditions;
          for (r in i) i[r] && ((i[r] = !1), (e = 1));
          e && t.revert();
        }) || Hc()
      );
    },
    addEventListener: function addEventListener(t, e) {
      var r = Oe[t] || (Oe[t] = []);
      ~r.indexOf(e) || r.push(e);
    },
    removeEventListener: function removeEventListener(t, e) {
      var r = Oe[t],
        i = r && r.indexOf(e);
      0 <= i && r.splice(i, 1);
    },
    utils: {
      wrap: function wrap(e, t, r) {
        var i = t - e;
        return K(e)
          ? ob(e, wrap(0, e.length), t)
          : Za(r, function (t) {
              return ((i + ((t - e) % i)) % i) + e;
            });
      },
      wrapYoyo: function wrapYoyo(e, t, r) {
        var i = t - e,
          n = 2 * i;
        return K(e)
          ? ob(e, wrapYoyo(0, e.length - 1), t)
          : Za(r, function (t) {
              return e + (i < (t = (n + ((t - e) % n)) % n || 0) ? n - t : t);
            });
      },
      distribute: hb,
      random: kb,
      snap: jb,
      normalize: function normalize(t, e, r) {
        return St(t, e, 0, 1, r);
      },
      getUnit: _a,
      clamp: function clamp(e, r, t) {
        return Za(t, function (t) {
          return Mt(e, r, t);
        });
      },
      splitColor: Db,
      toArray: Pt,
      selector: fb,
      mapRange: St,
      pipe: function pipe() {
        for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
          e[r] = arguments[r];
        return function (t) {
          return e.reduce(function (t, e) {
            return e(t);
          }, t);
        };
      },
      unitize: function unitize(e, r) {
        return function (t) {
          return e(parseFloat(t)) + (r || _a(t));
        };
      },
      interpolate: function interpolate(e, i, t, n) {
        var a = isNaN(e + i)
          ? 0
          : function (t) {
              return (1 - t) * e + t * i;
            };
        if (!a) {
          var s,
            o,
            u,
            h,
            l,
            f = r(e),
            c = {};
          if ((!0 === t && (n = 1) && (t = null), f))
            ((e = { p: e }), (i = { p: i }));
          else if (K(e) && !K(i)) {
            for (u = [], h = e.length, l = h - 2, o = 1; o < h; o++)
              u.push(interpolate(e[o - 1], e[o]));
            (h--,
              (a = function func(t) {
                t *= h;
                var e = Math.min(l, ~~t);
                return u[e](t - e);
              }),
              (t = i));
          } else n || (e = bt(K(e) ? [] : {}, e));
          if (!u) {
            for (s in i) $t.call(c, e, s, 'get', i[s]);
            a = function func(t) {
              return _e(t, c) || (f ? e.p : e);
            };
          }
        }
        return Za(t, a);
      },
      shuffle: gb,
    },
    install: R,
    effects: gt,
    ticker: It,
    updateRoot: Gt.updateRoot,
    plugins: mt,
    globalTimeline: L,
    core: {
      PropTween: we,
      globals: U,
      Tween: te,
      Timeline: Gt,
      Animation: qt,
      getCache: ha,
      _removeLinkedListItem: Ba,
      reverting: function reverting() {
        return I;
      },
      context: function context(t) {
        return (t && l && (l.data.push(t), (t._ctx = l)), l);
      },
      suppressOverwrites: function suppressOverwrites(t) {
        return (F = t);
      },
    },
  };
  (ja('to,from,fromTo,delayedCall,set,killTweensOf', function (t) {
    return (Ee[t] = te[t]);
  }),
    It.add(Gt.updateRoot),
    (c = Ee.to({}, { duration: 0 })));
  function Lc(t, e) {
    for (var r = t._pt; r && r.p !== e && r.op !== e && r.fp !== e; )
      r = r._next;
    return r;
  }
  function Nc(t, a) {
    return {
      name: t,
      headless: 1,
      rawVars: 1,
      init: function init(t, n, e) {
        e._onInit = function (t) {
          var e, i;
          if (
            (r(n) &&
              ((e = {}),
              ja(n, function (t) {
                return (e[t] = 1);
              }),
              (n = e)),
            a)
          ) {
            for (i in ((e = {}), n)) e[i] = a(n[i]);
            n = e;
          }
          !(function _addModifiers(t, e) {
            var r,
              i,
              n,
              a = t._targets;
            for (r in e)
              for (i = a.length; i--; )
                (n = (n = t._ptLookup[i][r]) && n.d) &&
                  (n._pt && (n = Lc(n, r)),
                  n && n.modifier && n.modifier(e[r], t, a[i], r));
          })(t, n);
        };
      },
    };
  }
  var Fe =
    Ee.registerPlugin(
      {
        name: 'attr',
        init: function init(t, e, r, i, n) {
          var a, s, o;
          for (a in ((this.tween = r), e))
            ((o = t.getAttribute(a) || ''),
              ((s = this.add(
                t,
                'setAttribute',
                (o || 0) + '',
                e[a],
                i,
                n,
                0,
                0,
                a
              )).op = a),
              (s.b = o),
              this._props.push(a));
        },
        render: function render(t, e) {
          for (var r = e._pt; r; )
            (I ? r.set(r.t, r.p, r.b, r) : r.r(t, r.d), (r = r._next));
        },
      },
      {
        name: 'endArray',
        headless: 1,
        init: function init(t, e) {
          for (var r = e.length; r--; )
            this.add(t, r, t[r] || 0, e[r], 0, 0, 0, 0, 0, 1);
        },
      },
      Nc('roundProps', ib),
      Nc('modifiers'),
      Nc('snap', jb)
    ) || Ee;
  ((te.version = Gt.version = Fe.version = '3.15.0'), (o = 1), x() && Lt());
  function xd(t, e) {
    return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
  }
  function yd(t, e) {
    return e.set(
      e.t,
      e.p,
      1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u,
      e
    );
  }
  function zd(t, e) {
    return e.set(
      e.t,
      e.p,
      t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b,
      e
    );
  }
  function Ad(t, e) {
    return e.set(
      e.t,
      e.p,
      1 === t ? e.e : t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b,
      e
    );
  }
  function Bd(t, e) {
    var r = e.s + e.c * t;
    e.set(e.t, e.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + e.u, e);
  }
  function Cd(t, e) {
    return e.set(e.t, e.p, t ? e.e : e.b, e);
  }
  function Dd(t, e) {
    return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e);
  }
  function Ed(t, e, r) {
    return (t.style[e] = r);
  }
  function Fd(t, e, r) {
    return t.style.setProperty(e, r);
  }
  function Gd(t, e, r) {
    return (t._gsap[e] = r);
  }
  function Hd(t, e, r) {
    return (t._gsap.scaleX = t._gsap.scaleY = r);
  }
  function Id(t, e, r, i, n) {
    var a = t._gsap;
    ((a.scaleX = a.scaleY = r), a.renderTransform(n, a));
  }
  function Jd(t, e, r, i, n) {
    var a = t._gsap;
    ((a[e] = r), a.renderTransform(n, a));
  }
  function Md(t, e) {
    var r = this,
      i = this.target,
      n = i.style,
      a = i._gsap;
    if (t in ur && n) {
      if (((this.tfm = this.tfm || {}), 'transform' === t))
        return _r.transform.split(',').forEach(function (t) {
          return Md.call(r, t, e);
        });
      if (
        (~(t = _r[t] || t).indexOf(',')
          ? t.split(',').forEach(function (t) {
              return (r.tfm[t] = wr(i, t));
            })
          : (this.tfm[t] = a.x ? a[t] : wr(i, t)),
        t === gr && (this.tfm.zOrigin = a.zOrigin),
        0 <= this.props.indexOf(mr))
      )
        return;
      (a.svg &&
        ((this.svgo = i.getAttribute('data-svg-origin')),
        this.props.push(gr, e, '')),
        (t = mr));
    }
    (n || e) && this.props.push(t, e, n[t]);
  }
  function Nd(t) {
    t.translate &&
      (t.removeProperty('translate'),
      t.removeProperty('scale'),
      t.removeProperty('rotate'));
  }
  function Od() {
    var t,
      e,
      r = this.props,
      i = this.target,
      n = i.style,
      a = i._gsap;
    for (t = 0; t < r.length; t += 3)
      r[t + 1]
        ? 2 === r[t + 1]
          ? i[r[t]](r[t + 2])
          : (i[r[t]] = r[t + 2])
        : r[t + 2]
          ? (n[r[t]] = r[t + 2])
          : n.removeProperty(
              '--' === r[t].substr(0, 2)
                ? r[t]
                : r[t].replace(cr, '-$1').toLowerCase()
            );
    if (this.tfm) {
      for (e in this.tfm) a[e] = this.tfm[e];
      (a.svg &&
        (a.renderTransform(),
        i.setAttribute('data-svg-origin', this.svgo || '')),
        ((t = je()) && t.isStart) ||
          n[mr] ||
          (Nd(n),
          a.zOrigin &&
            n[gr] &&
            ((n[gr] += ' ' + a.zOrigin + 'px'),
            (a.zOrigin = 0),
            a.renderTransform()),
          (a.uncache = 1)));
    }
  }
  function Pd(t, e) {
    var r = { target: t, props: [], revert: Od, save: Md };
    return (
      t._gsap || Fe.core.getCache(t),
      e &&
        t.style &&
        t.nodeType &&
        e.split(',').forEach(function (t) {
          return r.save(t);
        }),
      r
    );
  }
  function Rd(t, e) {
    var r = Le.createElementNS
      ? Le.createElementNS(
          (e || 'http://www.w3.org/1999/xhtml').replace(/^https/, 'http'),
          t
        )
      : Le.createElement(t);
    return r && r.style ? r : Le.createElement(t);
  }
  function Sd(t, e, r) {
    var i = getComputedStyle(t);
    return (
      i[e] ||
      i.getPropertyValue(e.replace(cr, '-$1').toLowerCase()) ||
      i.getPropertyValue(e) ||
      (!r && Sd(t, yr(e) || e, 1)) ||
      ''
    );
  }
  function Vd() {
    (function _windowExists() {
      return 'undefined' != typeof window;
    })() &&
      window.document &&
      ((Ie = window),
      (Le = Ie.document),
      (Be = Le.documentElement),
      (Ue = Rd('div') || { style: {} }),
      Rd('div'),
      (mr = yr(mr)),
      (gr = mr + 'Origin'),
      (Ue.style.cssText =
        'border-width:0;line-height:0;position:absolute;padding:0'),
      (Ve = !!yr('perspective')),
      (je = Fe.core.reverting),
      (Ne = 1));
  }
  function Wd(t) {
    var e,
      r = t.ownerSVGElement,
      i = Rd(
        'svg',
        (r && r.getAttribute('xmlns')) || 'http://www.w3.org/2000/svg'
      ),
      n = t.cloneNode(!0);
    ((n.style.display = 'block'), i.appendChild(n), Be.appendChild(i));
    try {
      e = n.getBBox();
    } catch (t) {}
    return (i.removeChild(n), Be.removeChild(i), e);
  }
  function Xd(t, e) {
    for (var r = e.length; r--; )
      if (t.hasAttribute(e[r])) return t.getAttribute(e[r]);
  }
  function Yd(e) {
    var r, i;
    try {
      r = e.getBBox();
    } catch (t) {
      ((r = Wd(e)), (i = 1));
    }
    return (
      (r && (r.width || r.height)) || i || (r = Wd(e)),
      !r || r.width || r.x || r.y
        ? r
        : {
            x: +Xd(e, ['x', 'cx', 'x1']) || 0,
            y: +Xd(e, ['y', 'cy', 'y1']) || 0,
            width: 0,
            height: 0,
          }
    );
  }
  function Zd(t) {
    return !(!t.getCTM || (t.parentNode && !t.ownerSVGElement) || !Yd(t));
  }
  function $d(t, e) {
    if (e) {
      var r,
        i = t.style;
      (e in ur && e !== gr && (e = mr),
        i.removeProperty
          ? (('ms' !== (r = e.substr(0, 2)) && 'webkit' !== e.substr(0, 6)) ||
              (e = '-' + e),
            i.removeProperty(
              '--' === r ? e : e.replace(cr, '-$1').toLowerCase()
            ))
          : i.removeAttribute(e));
    }
  }
  function _d(t, e, r, i, n, a) {
    var s = new we(t._pt, e, r, 0, 1, a ? Dd : Cd);
    return (((t._pt = s).b = i), (s.e = n), t._props.push(r), s);
  }
  function ce(t, e, r, i) {
    var n,
      a,
      s,
      o,
      u = parseFloat(r) || 0,
      h = (r + '').trim().substr((u + '').length) || 'px',
      l = Ue.style,
      f = dr.test(e),
      c = 'svg' === t.tagName.toLowerCase(),
      d = (c ? 'client' : 'offset') + (f ? 'Width' : 'Height'),
      p = 'px' === i,
      _ = '%' === i;
    if (i === h || !u || Tr[i] || Tr[h]) return u;
    if (
      ('px' === h || p || (u = ce(t, e, r, 'px')),
      (o = t.getCTM && Zd(t)),
      (_ || '%' === h) && (ur[e] || ~e.indexOf('adius')))
    )
      return (
        (n = o ? t.getBBox()[f ? 'width' : 'height'] : t[d]),
        ka(_ ? (u / n) * 100 : (u / 100) * n)
      );
    if (
      ((l[f ? 'width' : 'height'] = 100 + (p ? h : i)),
      (a =
        ('rem' !== i && ~e.indexOf('adius')) ||
        ('em' === i && t.appendChild && !c)
          ? t
          : t.parentNode),
      o && (a = (t.ownerSVGElement || {}).parentNode),
      (a && a !== Le && a.appendChild) || (a = Le.body),
      (s = a._gsap) && _ && s.width && f && s.time === It.time && !s.uncache)
    )
      return ka((u / s.width) * 100);
    if (!_ || ('height' !== e && 'width' !== e))
      ((!_ && '%' !== h) ||
        br[Sd(a, 'display')] ||
        (l.position = Sd(t, 'position')),
        a === t && (l.position = 'static'),
        a.appendChild(Ue),
        (n = Ue[d]),
        a.removeChild(Ue),
        (l.position = 'absolute'));
    else {
      var m = t.style[e];
      ((t.style[e] = 100 + i), (n = t[d]), m ? (t.style[e] = m) : $d(t, e));
    }
    return (
      f && _ && (((s = ha(a)).time = It.time), (s.width = a[d])),
      ka(p ? (n * u) / 100 : n && u ? (100 / n) * u : 0)
    );
  }
  function ee(t, e, r, i) {
    if (!r || 'none' === r) {
      var n = yr(e, t, 1),
        a = n && Sd(t, n, 1);
      a && a !== r
        ? ((e = n), (r = a))
        : 'borderColor' === e && (r = Sd(t, 'borderTopColor'));
    }
    var s,
      o,
      u,
      h,
      l,
      f,
      c,
      d,
      p,
      _,
      m,
      g = new we(this._pt, t.style, e, 0, 1, pe),
      v = 0,
      y = 0;
    if (
      ((g.b = r),
      (g.e = i),
      (r += ''),
      'var(--' === (i += '').substring(0, 6) &&
        (i = Sd(t, i.substring(4, i.indexOf(')')))),
      'auto' === i &&
        ((f = t.style[e]),
        (t.style[e] = i),
        (i = Sd(t, e) || i),
        f ? (t.style[e] = f) : $d(t, e)),
      Ib((s = [r, i])),
      (i = s[1]),
      (u = (r = s[0]).match(nt) || []),
      (i.match(nt) || []).length)
    ) {
      for (; (o = nt.exec(i)); )
        ((c = o[0]),
          (p = i.substring(v, o.index)),
          l
            ? (l = (l + 1) % 5)
            : ('rgba(' !== p.substr(-5) && 'hsla(' !== p.substr(-5)) || (l = 1),
          c !== (f = u[y++] || '') &&
            ((h = parseFloat(f) || 0),
            (m = f.substr((h + '').length)),
            '=' === c.charAt(1) && (c = ma(h, c) + m),
            (d = parseFloat(c)),
            (_ = c.substr((d + '').length)),
            (v = nt.lastIndex - _.length),
            _ ||
              ((_ = _ || Y.units[e] || m),
              v === i.length && ((i += _), (g.e += _))),
            m !== _ && (h = ce(t, e, f, _) || 0),
            (g._pt = {
              _next: g._pt,
              p: p || 1 === y ? p : ',',
              s: h,
              c: d - h,
              m: (l && l < 4) || 'zIndex' === e ? Math.round : 0,
            })));
      g.c = v < i.length ? i.substring(v, i.length) : '';
    } else g.r = 'display' === e && 'none' === i ? Dd : Cd;
    return (st.test(i) && (g.e = 0), (this._pt = g));
  }
  function ge(t) {
    var e = t.split(' '),
      r = e[0],
      i = e[1] || '50%';
    return (
      ('top' !== r && 'bottom' !== r && 'left' !== i && 'right' !== i) ||
        ((t = r), (r = i), (i = t)),
      (e[0] = xr[r] || r),
      (e[1] = xr[i] || i),
      e.join(' ')
    );
  }
  function he(t, e) {
    if (e.tween && e.tween._time === e.tween._dur) {
      var r,
        i,
        n,
        a = e.t,
        s = a.style,
        o = e.u,
        u = a._gsap;
      if ('all' === o || !0 === o) ((s.cssText = ''), (i = 1));
      else
        for (n = (o = o.split(',')).length; -1 < --n; )
          ((r = o[n]),
            ur[r] && ((i = 1), (r = 'transformOrigin' === r ? gr : mr)),
            $d(a, r));
      i &&
        ($d(a, mr),
        u &&
          (u.svg && a.removeAttribute('transform'),
          (s.scale = s.rotate = s.translate = 'none'),
          Cr(a, 1),
          (u.uncache = 1),
          Nd(s)));
    }
  }
  function le(t) {
    return 'matrix(1, 0, 0, 1, 0, 0)' === t || 'none' === t || !t;
  }
  function me(t) {
    var e = Sd(t, mr);
    return le(e) ? Or : e.substr(7).match(it).map(ka);
  }
  function ne(t, e) {
    var r,
      i,
      n,
      a,
      s = t._gsap || ha(t),
      o = t.style,
      u = me(t);
    return s.svg && t.getAttribute('transform')
      ? '1,0,0,1,0,0' ===
        (u = [
          (n = t.transform.baseVal.consolidate().matrix).a,
          n.b,
          n.c,
          n.d,
          n.e,
          n.f,
        ]).join(',')
        ? Or
        : u
      : (u !== Or ||
          t.offsetParent ||
          t === Be ||
          s.svg ||
          ((n = o.display),
          (o.display = 'block'),
          ((r = t.parentNode) &&
            (t.offsetParent || t.getBoundingClientRect().width)) ||
            ((a = 1), (i = t.nextElementSibling), Be.appendChild(t)),
          (u = me(t)),
          n ? (o.display = n) : $d(t, 'display'),
          a &&
            (i
              ? r.insertBefore(t, i)
              : r
                ? r.appendChild(t)
                : Be.removeChild(t))),
        e && 6 < u.length ? [u[0], u[1], u[4], u[5], u[12], u[13]] : u);
  }
  function oe(t, e, r, i, n, a) {
    var s,
      o,
      u,
      h = t._gsap,
      l = n || ne(t, !0),
      f = h.xOrigin || 0,
      c = h.yOrigin || 0,
      d = h.xOffset || 0,
      p = h.yOffset || 0,
      _ = l[0],
      m = l[1],
      g = l[2],
      v = l[3],
      y = l[4],
      T = l[5],
      b = e.split(' '),
      w = parseFloat(b[0]) || 0,
      x = parseFloat(b[1]) || 0;
    (r
      ? l !== Or &&
        (o = _ * v - m * g) &&
        ((u = w * (-m / o) + x * (_ / o) - (_ * T - m * y) / o),
        (w = w * (v / o) + x * (-g / o) + (g * T - v * y) / o),
        (x = u))
      : ((w = (s = Yd(t)).x + (~b[0].indexOf('%') ? (w / 100) * s.width : w)),
        (x = s.y + (~(b[1] || b[0]).indexOf('%') ? (x / 100) * s.height : x))),
      i || (!1 !== i && h.smooth)
        ? ((y = w - f),
          (T = x - c),
          (h.xOffset = d + (y * _ + T * g) - y),
          (h.yOffset = p + (y * m + T * v) - T))
        : (h.xOffset = h.yOffset = 0),
      (h.xOrigin = w),
      (h.yOrigin = x),
      (h.smooth = !!i),
      (h.origin = e),
      (h.originIsAbsolute = !!r),
      (t.style[gr] = '0px 0px'),
      a &&
        (_d(a, h, 'xOrigin', f, w),
        _d(a, h, 'yOrigin', c, x),
        _d(a, h, 'xOffset', d, h.xOffset),
        _d(a, h, 'yOffset', p, h.yOffset)),
      t.setAttribute('data-svg-origin', w + ' ' + x));
  }
  function re(t, e, r) {
    var i = _a(e);
    return ka(parseFloat(e) + parseFloat(ce(t, 'x', r + 'px', i))) + i;
  }
  function ye(t, e, i, n, a) {
    var s,
      o,
      u = 360,
      h = r(a),
      l = parseFloat(a) * (h && ~a.indexOf('rad') ? hr : 1) - n,
      f = n + l + 'deg';
    return (
      h &&
        ('short' === (s = a.split('_')[1]) &&
          (l %= u) !== l % 180 &&
          (l += l < 0 ? u : -u),
        'cw' === s && l < 0
          ? (l = ((l + 36e9) % u) - ~~(l / u) * u)
          : 'ccw' === s && 0 < l && (l = ((l - 36e9) % u) - ~~(l / u) * u)),
      (t._pt = o = new we(t._pt, e, i, n, l, yd)),
      (o.e = f),
      (o.u = 'deg'),
      t._props.push(i),
      o
    );
  }
  function ze(t, e) {
    for (var r in e) t[r] = e[r];
    return t;
  }
  function Ae(t, e, r) {
    var i,
      n,
      a,
      s,
      o,
      u,
      h,
      l = ze({}, r._gsap),
      f = r.style;
    for (n in (l.svg
      ? ((a = r.getAttribute('transform')),
        r.setAttribute('transform', ''),
        (f[mr] = e),
        (i = Cr(r, 1)),
        $d(r, mr),
        r.setAttribute('transform', a))
      : ((a = getComputedStyle(r)[mr]),
        (f[mr] = e),
        (i = Cr(r, 1)),
        (f[mr] = a)),
    ur))
      (a = l[n]) !== (s = i[n]) &&
        'perspective,force3D,transformOrigin,svgOrigin'.indexOf(n) < 0 &&
        ((o = _a(a) !== (h = _a(s)) ? ce(r, n, a, h) : parseFloat(a)),
        (u = parseFloat(s)),
        (t._pt = new we(t._pt, i, n, o, u - o, xd)),
        (t._pt.u = h || 0),
        t._props.push(n));
    ze(i, l);
  }
  var Ie,
    Le,
    Be,
    Ne,
    Ue,
    Ye,
    je,
    Ve,
    Xe = Bt.Power0,
    qe = Bt.Power1,
    Ge = Bt.Power2,
    Ze = Bt.Power3,
    We = Bt.Power4,
    $e = Bt.Linear,
    He = Bt.Quad,
    Qe = Bt.Cubic,
    Je = Bt.Quart,
    Ke = Bt.Quint,
    tr = Bt.Strong,
    er = Bt.Elastic,
    rr = Bt.Back,
    ir = Bt.SteppedEase,
    nr = Bt.Bounce,
    ar = Bt.Sine,
    sr = Bt.Expo,
    or = Bt.Circ,
    ur = {},
    hr = 180 / Math.PI,
    lr = Math.PI / 180,
    fr = Math.atan2,
    cr = /([A-Z])/g,
    dr = /(left|right|width|margin|padding|x)/i,
    pr = /[\s,\(]\S/,
    _r = {
      autoAlpha: 'opacity,visibility',
      scale: 'scaleX,scaleY',
      alpha: 'opacity',
    },
    mr = 'transform',
    gr = mr + 'Origin',
    vr = 'O,Moz,ms,Ms,Webkit'.split(','),
    yr = function _checkPropPrefix(t, e, r) {
      var i = (e || Ue).style,
        n = 5;
      if (t in i && !r) return t;
      for (
        t = t.charAt(0).toUpperCase() + t.substr(1);
        n-- && !(vr[n] + t in i);
      );
      return n < 0 ? null : (3 === n ? 'ms' : 0 <= n ? vr[n] : '') + t;
    },
    Tr = { deg: 1, rad: 1, turn: 1 },
    br = { grid: 1, flex: 1 },
    wr = function _get(t, e, r, i) {
      var n;
      return (
        Ne || Vd(),
        e in _r &&
          'transform' !== e &&
          ~(e = _r[e]).indexOf(',') &&
          (e = e.split(',')[0]),
        ur[e] && 'transform' !== e
          ? ((n = Cr(t, i)),
            (n =
              'transformOrigin' !== e
                ? n[e]
                : n.svg
                  ? n.origin
                  : Pr(Sd(t, gr)) + ' ' + n.zOrigin + 'px'))
          : ((n = t.style[e]) &&
              'auto' !== n &&
              !i &&
              !~(n + '').indexOf('calc(')) ||
            (n =
              (kr[e] && kr[e](t, e, r)) ||
              Sd(t, e) ||
              ia(t, e) ||
              ('opacity' === e ? 1 : 0)),
        r && !~(n + '').trim().indexOf(' ') ? ce(t, e, n, r) + r : n
      );
    },
    xr = {
      top: '0%',
      bottom: '100%',
      left: '0%',
      right: '100%',
      center: '50%',
    },
    kr = {
      clearProps: function clearProps(t, e, r, i, n) {
        if ('isFromStart' !== n.data) {
          var a = (t._pt = new we(t._pt, e, r, 0, 0, he));
          return ((a.u = i), (a.pr = -10), (a.tween = n), t._props.push(r), 1);
        }
      },
    },
    Or = [1, 0, 0, 1, 0, 0],
    Mr = {},
    Cr = function _parseTransform(t, e) {
      var r = t._gsap || new Xt(t);
      if ('x' in r && !e && !r.uncache) return r;
      var i,
        n,
        a,
        s,
        o,
        u,
        h,
        l,
        f,
        c,
        d,
        p,
        _,
        m,
        g,
        v,
        y,
        T,
        b,
        w,
        x,
        k,
        O,
        M,
        C,
        P,
        S,
        A,
        D,
        z,
        R,
        E,
        F = t.style,
        I = r.scaleX < 0,
        L = 'deg',
        B = getComputedStyle(t),
        N = Sd(t, gr) || '0';
      return (
        (i = n = a = u = h = l = f = c = d = 0),
        (s = o = 1),
        (r.svg = !(!t.getCTM || !Zd(t))),
        B.translate &&
          (('none' === B.translate &&
            'none' === B.scale &&
            'none' === B.rotate) ||
            (F[mr] =
              ('none' !== B.translate
                ? 'translate3d(' +
                  (B.translate + ' 0 0').split(' ').slice(0, 3).join(', ') +
                  ') '
                : '') +
              ('none' !== B.rotate ? 'rotate(' + B.rotate + ') ' : '') +
              ('none' !== B.scale
                ? 'scale(' + B.scale.split(' ').join(',') + ') '
                : '') +
              ('none' !== B[mr] ? B[mr] : '')),
          (F.scale = F.rotate = F.translate = 'none')),
        (m = ne(t, r.svg)),
        r.svg &&
          ((M = r.uncache
            ? ((C = t.getBBox()),
              (N = r.xOrigin - C.x + 'px ' + (r.yOrigin - C.y) + 'px'),
              '')
            : !e && t.getAttribute('data-svg-origin')),
          oe(t, M || N, !!M || r.originIsAbsolute, !1 !== r.smooth, m)),
        (p = r.xOrigin || 0),
        (_ = r.yOrigin || 0),
        m !== Or &&
          ((T = m[0]),
          (b = m[1]),
          (w = m[2]),
          (x = m[3]),
          (i = k = m[4]),
          (n = O = m[5]),
          6 === m.length
            ? ((s = Math.sqrt(T * T + b * b)),
              (o = Math.sqrt(x * x + w * w)),
              (u = T || b ? fr(b, T) * hr : 0),
              (f = w || x ? fr(w, x) * hr + u : 0) &&
                (o *= Math.abs(Math.cos(f * lr))),
              r.svg && ((i -= p - (p * T + _ * w)), (n -= _ - (p * b + _ * x))))
            : ((E = m[6]),
              (z = m[7]),
              (S = m[8]),
              (A = m[9]),
              (D = m[10]),
              (R = m[11]),
              (i = m[12]),
              (n = m[13]),
              (a = m[14]),
              (h = (g = fr(E, D)) * hr),
              g &&
                ((M = k * (v = Math.cos(-g)) + S * (y = Math.sin(-g))),
                (C = O * v + A * y),
                (P = E * v + D * y),
                (S = k * -y + S * v),
                (A = O * -y + A * v),
                (D = E * -y + D * v),
                (R = z * -y + R * v),
                (k = M),
                (O = C),
                (E = P)),
              (l = (g = fr(-w, D)) * hr),
              g &&
                ((v = Math.cos(-g)),
                (R = x * (y = Math.sin(-g)) + R * v),
                (T = M = T * v - S * y),
                (b = C = b * v - A * y),
                (w = P = w * v - D * y)),
              (u = (g = fr(b, T)) * hr),
              g &&
                ((M = T * (v = Math.cos(g)) + b * (y = Math.sin(g))),
                (C = k * v + O * y),
                (b = b * v - T * y),
                (O = O * v - k * y),
                (T = M),
                (k = C)),
              h &&
                359.9 < Math.abs(h) + Math.abs(u) &&
                ((h = u = 0), (l = 180 - l)),
              (s = ka(Math.sqrt(T * T + b * b + w * w))),
              (o = ka(Math.sqrt(O * O + E * E))),
              (g = fr(k, O)),
              (f = 2e-4 < Math.abs(g) ? g * hr : 0),
              (d = R ? 1 / (R < 0 ? -R : R) : 0)),
          r.svg &&
            ((M = t.getAttribute('transform')),
            (r.forceCSS = t.setAttribute('transform', '') || !le(Sd(t, mr))),
            M && t.setAttribute('transform', M))),
        90 < Math.abs(f) &&
          Math.abs(f) < 270 &&
          (I
            ? ((s *= -1),
              (f += u <= 0 ? 180 : -180),
              (u += u <= 0 ? 180 : -180))
            : ((o *= -1), (f += f <= 0 ? 180 : -180))),
        (e = e || r.uncache),
        (r.x =
          i -
          ((r.xPercent =
            i &&
            ((!e && r.xPercent) ||
              (Math.round(t.offsetWidth / 2) === Math.round(-i) ? -50 : 0)))
            ? (t.offsetWidth * r.xPercent) / 100
            : 0) +
          'px'),
        (r.y =
          n -
          ((r.yPercent =
            n &&
            ((!e && r.yPercent) ||
              (Math.round(t.offsetHeight / 2) === Math.round(-n) ? -50 : 0)))
            ? (t.offsetHeight * r.yPercent) / 100
            : 0) +
          'px'),
        (r.z = a + 'px'),
        (r.scaleX = ka(s)),
        (r.scaleY = ka(o)),
        (r.rotation = ka(u) + L),
        (r.rotationX = ka(h) + L),
        (r.rotationY = ka(l) + L),
        (r.skewX = f + L),
        (r.skewY = c + L),
        (r.transformPerspective = d + 'px'),
        (r.zOrigin = parseFloat(N.split(' ')[2]) || (!e && r.zOrigin) || 0) &&
          (F[gr] = Pr(N)),
        (r.xOffset = r.yOffset = 0),
        (r.force3D = Y.force3D),
        (r.renderTransform = r.svg ? Er : Ve ? Rr : Sr),
        (r.uncache = 0),
        r
      );
    },
    Pr = function _firstTwoOnly(t) {
      return (t = t.split(' '))[0] + ' ' + t[1];
    },
    Sr = function _renderNon3DTransforms(t, e) {
      ((e.z = '0px'),
        (e.rotationY = e.rotationX = '0deg'),
        (e.force3D = 0),
        Rr(t, e));
    },
    Ar = '0deg',
    Dr = '0px',
    zr = ') ',
    Rr = function _renderCSSTransforms(t, e) {
      var r = e || this,
        i = r.xPercent,
        n = r.yPercent,
        a = r.x,
        s = r.y,
        o = r.z,
        u = r.rotation,
        h = r.rotationY,
        l = r.rotationX,
        f = r.skewX,
        c = r.skewY,
        d = r.scaleX,
        p = r.scaleY,
        _ = r.transformPerspective,
        m = r.force3D,
        g = r.target,
        v = r.zOrigin,
        y = '',
        T = ('auto' === m && t && 1 !== t) || !0 === m;
      if (v && (l !== Ar || h !== Ar)) {
        var b,
          w = parseFloat(h) * lr,
          x = Math.sin(w),
          k = Math.cos(w);
        ((w = parseFloat(l) * lr),
          (b = Math.cos(w)),
          (a = re(g, a, x * b * -v)),
          (s = re(g, s, -Math.sin(w) * -v)),
          (o = re(g, o, k * b * -v + v)));
      }
      (_ !== Dr && (y += 'perspective(' + _ + zr),
        (i || n) && (y += 'translate(' + i + '%, ' + n + '%) '),
        (!T && a === Dr && s === Dr && o === Dr) ||
          (y +=
            o !== Dr || T
              ? 'translate3d(' + a + ', ' + s + ', ' + o + ') '
              : 'translate(' + a + ', ' + s + zr),
        u !== Ar && (y += 'rotate(' + u + zr),
        h !== Ar && (y += 'rotateY(' + h + zr),
        l !== Ar && (y += 'rotateX(' + l + zr),
        (f === Ar && c === Ar) || (y += 'skew(' + f + ', ' + c + zr),
        (1 === d && 1 === p) || (y += 'scale(' + d + ', ' + p + zr),
        (g.style[mr] = y || 'translate(0, 0)'));
    },
    Er = function _renderSVGTransforms(t, e) {
      var r,
        i,
        n,
        a,
        s,
        o = e || this,
        u = o.xPercent,
        h = o.yPercent,
        l = o.x,
        f = o.y,
        c = o.rotation,
        d = o.skewX,
        p = o.skewY,
        _ = o.scaleX,
        m = o.scaleY,
        g = o.target,
        v = o.xOrigin,
        y = o.yOrigin,
        T = o.xOffset,
        b = o.yOffset,
        w = o.forceCSS,
        x = parseFloat(l),
        k = parseFloat(f);
      ((c = parseFloat(c)),
        (d = parseFloat(d)),
        (p = parseFloat(p)) && ((d += p = parseFloat(p)), (c += p)),
        c || d
          ? ((c *= lr),
            (d *= lr),
            (r = Math.cos(c) * _),
            (i = Math.sin(c) * _),
            (n = Math.sin(c - d) * -m),
            (a = Math.cos(c - d) * m),
            d &&
              ((p *= lr),
              (s = Math.tan(d - p)),
              (n *= s = Math.sqrt(1 + s * s)),
              (a *= s),
              p &&
                ((s = Math.tan(p)), (r *= s = Math.sqrt(1 + s * s)), (i *= s))),
            (r = ka(r)),
            (i = ka(i)),
            (n = ka(n)),
            (a = ka(a)))
          : ((r = _), (a = m), (i = n = 0)),
        ((x && !~(l + '').indexOf('px')) || (k && !~(f + '').indexOf('px'))) &&
          ((x = ce(g, 'x', l, 'px')), (k = ce(g, 'y', f, 'px'))),
        (v || y || T || b) &&
          ((x = ka(x + v - (v * r + y * n) + T)),
          (k = ka(k + y - (v * i + y * a) + b))),
        (u || h) &&
          ((s = g.getBBox()),
          (x = ka(x + (u / 100) * s.width)),
          (k = ka(k + (h / 100) * s.height))),
        (s =
          'matrix(' +
          r +
          ',' +
          i +
          ',' +
          n +
          ',' +
          a +
          ',' +
          x +
          ',' +
          k +
          ')'),
        g.setAttribute('transform', s),
        w && (g.style[mr] = s));
    };
  ja('padding,margin,Width,Radius', function (e, r) {
    var t = 'Right',
      i = 'Bottom',
      n = 'Left',
      o = (r < 3 ? ['Top', t, i, n] : ['Top' + n, 'Top' + t, i + t, i + n]).map(
        function (t) {
          return r < 2 ? e + t : 'border' + t + e;
        }
      );
    kr[1 < r ? 'border' + e : e] = function (e, t, r, i, n) {
      var a, s;
      if (arguments.length < 4)
        return (
          (a = o.map(function (t) {
            return wr(e, t, r);
          })),
          5 === (s = a.join(' ')).split(a[0]).length ? a[0] : s
        );
      ((a = (i + '').split(' ')),
        (s = {}),
        o.forEach(function (t, e) {
          return (s[t] = a[e] = a[e] || a[((e - 1) / 2) | 0]);
        }),
        e.init(t, s, n));
    };
  });
  var Fr,
    Ir,
    Lr,
    Br = {
      name: 'css',
      register: Vd,
      targetTest: function targetTest(t) {
        return t.style && t.nodeType;
      },
      init: function init(t, e, i, n, a) {
        var s,
          o,
          u,
          h,
          l,
          f,
          c,
          d,
          p,
          _,
          m,
          g,
          v,
          y,
          T,
          b,
          w,
          x = this._props,
          k = t.style,
          O = i.vars.startAt;
        for (c in (Ne || Vd(),
        (this.styles = this.styles || Pd(t)),
        (b = this.styles.props),
        (this.tween = i),
        e))
          if (
            'autoRound' !== c &&
            ((o = e[c]), !mt[c] || !cc(c, e, i, n, t, a))
          )
            if (
              ((l = typeof o),
              (f = kr[c]),
              'function' === l && (l = typeof (o = o.call(i, n, t, a))),
              'string' === l && ~o.indexOf('random(') && (o = rb(o)),
              f)
            )
              f(this, t, c, o, i) && (T = 1);
            else if ('--' === c.substr(0, 2))
              ((s = (getComputedStyle(t).getPropertyValue(c) + '').trim()),
                (o += ''),
                (Et.lastIndex = 0),
                Et.test(s) ||
                  ((d = _a(s)),
                  (p = _a(o))
                    ? d !== p && (s = ce(t, c, s, p) + p)
                    : d && (o += d)),
                this.add(k, 'setProperty', s, o, n, a, 0, 0, c),
                x.push(c),
                b.push(c, 0, k[c]));
            else if ('undefined' !== l) {
              if (
                (O && c in O
                  ? ((s =
                      'function' == typeof O[c] ? O[c].call(i, n, t, a) : O[c]),
                    r(s) && ~s.indexOf('random(') && (s = rb(s)),
                    _a(s + '') ||
                      'auto' === s ||
                      (s += Y.units[c] || _a(wr(t, c)) || ''),
                    '=' === (s + '').charAt(1) && (s = wr(t, c)))
                  : (s = wr(t, c)),
                (h = parseFloat(s)),
                (_ = 'string' === l && '=' === o.charAt(1) && o.substr(0, 2)) &&
                  (o = o.substr(2)),
                (u = parseFloat(o)),
                c in _r &&
                  ('autoAlpha' === c &&
                    (1 === h &&
                      'hidden' === wr(t, 'visibility') &&
                      u &&
                      (h = 0),
                    b.push('visibility', 0, k.visibility),
                    _d(
                      this,
                      k,
                      'visibility',
                      h ? 'inherit' : 'hidden',
                      u ? 'inherit' : 'hidden',
                      !u
                    )),
                  'scale' !== c &&
                    'transform' !== c &&
                    ~(c = _r[c]).indexOf(',') &&
                    (c = c.split(',')[0])),
                (m = c in ur))
              ) {
                if (
                  (this.styles.save(c),
                  (w = o),
                  'string' === l && 'var(--' === o.substring(0, 6))
                ) {
                  if (
                    'calc(' ===
                    (o = Sd(t, o.substring(4, o.indexOf(')')))).substring(0, 5)
                  ) {
                    var M = t.style.perspective;
                    ((t.style.perspective = o),
                      (o = Sd(t, 'perspective')),
                      M ? (t.style.perspective = M) : $d(t, 'perspective'));
                  }
                  u = parseFloat(o);
                }
                if (
                  (g ||
                    (((v = t._gsap).renderTransform && !e.parseTransform) ||
                      Cr(t, e.parseTransform),
                    (y = !1 !== e.smoothOrigin && v.smooth),
                    ((g = this._pt =
                      new we(
                        this._pt,
                        k,
                        mr,
                        0,
                        1,
                        v.renderTransform,
                        v,
                        0,
                        -1
                      )).dep = 1)),
                  'scale' === c)
                )
                  ((this._pt = new we(
                    this._pt,
                    v,
                    'scaleY',
                    v.scaleY,
                    (_ ? ma(v.scaleY, _ + u) : u) - v.scaleY || 0,
                    xd
                  )),
                    (this._pt.u = 0),
                    x.push('scaleY', c),
                    (c += 'X'));
                else {
                  if ('transformOrigin' === c) {
                    (b.push(gr, 0, k[gr]),
                      (o = ge(o)),
                      v.svg
                        ? oe(t, o, 0, y, 0, this)
                        : ((p = parseFloat(o.split(' ')[2]) || 0) !==
                            v.zOrigin && _d(this, v, 'zOrigin', v.zOrigin, p),
                          _d(this, k, c, Pr(s), Pr(o))));
                    continue;
                  }
                  if ('svgOrigin' === c) {
                    oe(t, o, 1, y, 0, this);
                    continue;
                  }
                  if (c in Mr) {
                    ye(this, v, c, h, _ ? ma(h, _ + o) : o);
                    continue;
                  }
                  if ('smoothOrigin' === c) {
                    _d(this, v, 'smooth', v.smooth, o);
                    continue;
                  }
                  if ('force3D' === c) {
                    v[c] = o;
                    continue;
                  }
                  if ('transform' === c) {
                    Ae(this, o, t);
                    continue;
                  }
                }
              } else c in k || (c = yr(c) || c);
              if (
                m ||
                ((u || 0 === u) && (h || 0 === h) && !pr.test(o) && c in k)
              )
                ((u = u || 0),
                  (d = (s + '').substr((h + '').length)) !==
                    (p = _a(o) || (c in Y.units ? Y.units[c] : d)) &&
                    (h = ce(t, c, s, p)),
                  (this._pt = new we(
                    this._pt,
                    m ? v : k,
                    c,
                    h,
                    (_ ? ma(h, _ + u) : u) - h,
                    m || ('px' !== p && 'zIndex' !== c) || !1 === e.autoRound
                      ? xd
                      : Bd
                  )),
                  (this._pt.u = p || 0),
                  m && w !== o
                    ? ((this._pt.b = s), (this._pt.e = w), (this._pt.r = Ad))
                    : d !== p &&
                      '%' !== p &&
                      ((this._pt.b = s), (this._pt.r = zd)));
              else if (c in k) ee.call(this, t, c, s, _ ? _ + o : o);
              else if (c in t) this.add(t, c, s || t[c], _ ? _ + o : o, n, a);
              else if ('parseTransform' !== c) {
                S(c, o);
                continue;
              }
              (m ||
                (c in k
                  ? b.push(c, 0, k[c])
                  : 'function' == typeof t[c]
                    ? b.push(c, 2, t[c]())
                    : b.push(c, 1, s || t[c])),
                x.push(c));
            }
        T && be(this);
      },
      render: function render(t, e) {
        if (e.tween._time || !je())
          for (var r = e._pt; r; ) (r.r(t, r.d), (r = r._next));
        else e.styles.revert();
      },
      get: wr,
      aliases: _r,
      getSetter: function getSetter(t, e, r) {
        var i = _r[e];
        return (
          i && i.indexOf(',') < 0 && (e = i),
          e in ur && e !== gr && (t._gsap.x || wr(t, 'x'))
            ? r && Ye === r
              ? 'scale' === e
                ? Hd
                : Gd
              : (Ye = r || {}) && ('scale' === e ? Id : Jd)
            : t.style && !u(t.style[e])
              ? Ed
              : ~e.indexOf('-')
                ? Fd
                : ue(t, e)
        );
      },
      core: { _removeProperty: $d, _getMatrix: ne },
    };
  ((Fe.utils.checkPrefix = yr),
    (Fe.core.getStyleSaver = Pd),
    (Lr = ja(
      (Fr = 'x,y,z,scale,scaleX,scaleY,xPercent,yPercent') +
        ',' +
        (Ir = 'rotation,rotationX,rotationY,skewX,skewY') +
        ',transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective',
      function (t) {
        ur[t] = 1;
      }
    )),
    ja(Ir, function (t) {
      ((Y.units[t] = 'deg'), (Mr[t] = 1));
    }),
    (_r[Lr[13]] = Fr + ',' + Ir),
    ja(
      '0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY',
      function (t) {
        var e = t.split(':');
        _r[e[1]] = Lr[e[0]];
      }
    ),
    ja(
      'x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective',
      function (t) {
        Y.units[t] = 'px';
      }
    ),
    Fe.registerPlugin(Br));
  var Nr = Fe.registerPlugin(Br) || Fe,
    Ur = Nr.core.Tween;
  ((e.Back = rr),
    (e.Bounce = nr),
    (e.CSSPlugin = Br),
    (e.Circ = or),
    (e.Cubic = Qe),
    (e.Elastic = er),
    (e.Expo = sr),
    (e.Linear = $e),
    (e.Power0 = Xe),
    (e.Power1 = qe),
    (e.Power2 = Ge),
    (e.Power3 = Ze),
    (e.Power4 = We),
    (e.Quad = He),
    (e.Quart = Je),
    (e.Quint = Ke),
    (e.Sine = ar),
    (e.SteppedEase = ir),
    (e.Strong = tr),
    (e.TimelineLite = Gt),
    (e.TimelineMax = Gt),
    (e.TweenLite = te),
    (e.TweenMax = Ur),
    (e.default = Nr),
    (e.gsap = Nr));
  if (typeof window === 'undefined' || window !== e) {
    Object.defineProperty(e, '__esModule', { value: !0 });
  } else {
    delete e.default;
  }
});
